import React, { useState, useEffect, useCallback, useRef, createRef, useMemo } from 'react';
import {
   useColorModeValue,
   Card,
   Grid,
   GridItem,
   Button,
   CardBody,
   CardHeader,
   Heading,
   useToast,
   CardFooter,
   Flex,
   useDisclosure,
   Box,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   IconButton,
   Image,
   Text,
   Badge,
   Icon,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
} from '@chakra-ui/react';
import { FaHistory } from 'react-icons/fa';
import { getSerialWiseHistory } from '../../../../../redux/actions/salesLineDetail';
import { FaCircleInfo } from 'react-icons/fa6';
import { getAdjustedDocs } from '../../../../../redux/actions/salesInvoice';
import * as Yup from 'yup';
import moment from 'moment';
import Swal from 'sweetalert2';
import _ from 'lodash';

// UI
// import LineItem from '../../../sales/Pages/SalesInvoiceMaster/LineItem';
import LineItem from 'components/LineItem';
import BillTerm from '../../../sales/Pages/SalesInvoiceMaster/BillTerm';
import TaxableAmount from '../../../sales/Pages/SalesInvoiceMaster/TaxableAmount';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as dynamicDropdown } from 'components/ui/DynamicDropdown';
import InputField from 'components/ui/InputField';
import SerialNumberModal from './SerialNumberModal';
import CustomerVerifyModal from './CustomerVerifyModal';
import TextareaField from 'components/ui/TextareaField';
import PrintFormat from 'components/PrintFormate/PrintFormat';
import AccountSelect from 'components/AccountSelect/AccountSelect';
import TakaForm from './TakaForm';
import IssueToMill from './IssueToMill';
import SelectTakaDetail from './SelectTakaDetail';
import SelectTakaDetailChallan from '../../../inventory/Pages/IssueMaster/SelectTakaDetail';
import { getOrderDocument, getChallanDocument } from '../../../../../redux/actions/PurchaseChallan';


import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// contexts
import { useUser, useGlobal, useBusinessType, useAccount, useDaybook, useItem } from '../../../../../contexts';

// hooks
import useCalculateTaxAmount from 'hooks/useSalesTaxAmount';
import usePurchaseLastDaybook from 'hooks/usePurchaseLastDaybook';

// Actions
import { getStock } from '../../../../../redux/actions/salesLineDetail';
import { getAccount } from '../../../../../redux/actions/account';
import { getPaymentDaybook, getDaybookById, getDaybook, updateDaybook } from '../../../../../redux/actions/daybook';
import { getItem } from '../../../../../redux/actions/item';
import { getMainAndSubHsn } from '../../../../../redux/actions/mainAndSubHsn';
import { getWarehouse } from '../../../../../redux/actions/warehouse';
import { getGLGroupsAllDropdown } from '../../../../../redux/actions/glGroup';
import {
   addPurchaseInvoice,
   updatePurchaseInvoice,
   getPurchaseInvoice,
   getPurchaseInvoices,
   deletePurchaseLineItem,
   emptyPurchase,
   getPrevAndNext,
   checkDocNo,
   getLastPurchaseDaybook,
   uploadPurchaseDocument,
} from '../../../../../redux/actions/purchaseInvoice';
import { getBillTerm } from '../../../../../redux/actions/billTerm';
import { getSetupFormat, setupFormatCustomQuery } from '../../../../../redux/actions/setupFormat';
import { getIssuesDocument } from '../../../../../redux/actions/issue';
import { getUsers } from '../../../../../redux/actions/user';
import { getFinancialYears } from '../../../../../redux/actions/dashboard';
import { getItemPrice } from '../../../../../redux/actions/salesInvoice';
import { getMillPendingIssue } from "../../../../../redux/actions/issueInventory"

// utils
import {
   removeDuplicates,
   getAccountAddress,
   getGstTaxType,
   getGstSubTaxType,
   handlePrintClick,
   injectDataIntoHtml,
   getFirstErrorMessage,
   formatAmount,
   getFinancialYear,
   getGstRate,
   removeLinkedIssueLineDetails,
   removeDuplicateItdRecords,
   mergeUsedMeter
} from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

// icons
import { FaTrash } from 'react-icons/fa';

// image
import phone from 'assets/img/nfts/phone.svg';
import Email from 'assets/img/nfts/email.svg';
import map from 'assets/img/nfts/map.svg';
import panno from 'assets/img/nfts/panno.svg';
import gstno from 'assets/img/nfts/gstno.svg';
import Brokername from 'assets/img/nfts/Brokername.svg';
import Balance from 'assets/img/nfts/Balance.svg';
import loaderAnimation from 'assets/img/auth/loding.gif';
import back from 'assets/img/nfts/back.svg';

import DeleteDialog from '../../../masters/components/DeleteDialog';

import { USER_TYPES } from 'constants';

const validationSchema = Yup.object().shape({
   header: Yup.object().shape({
      daybookId: Yup.number()
         .typeError('Daybook is required')
         .required('Daybook is required')
         .positive('Invalid daybook selected'),

      docno: Yup.string().required('Document number is required').trim(),
      partyNo: Yup.string().required('Party number is required').trim(),
      partyDate: Yup.date().required('Party date is required'),
      transactionAt: Yup.date()
         .required('Transaction date is required'),
      // .max(new Date(new Date().setHours(23, 59, 59, 999)), 'Transaction date cannot be in the future'),

      accountId: Yup.number()
         .typeError('Account is required')
         .required('Account is required')
         .positive('Invalid account selected'),

      basicAmount: Yup.number().required('Basic amount is required').min(0, 'Basic amount cannot be negative'),
      netAmount: Yup.number().required('Net amount is required'),
   }),

   lineItem: Yup.array()
      .required('Line items are required')
      .min(1, 'At least one line item is required')
      .of(
         Yup.object().shape({
            itemId: Yup.number()
               .typeError('Item is required')
               .required('Item is required')
               .positive('Invalid item selected'),

            itemRate: Yup.number().required('Item rate is required').min(0, 'Item rate cannot be negative'),

            qty1: Yup.number().required('Quantity is required').min(0, 'Quantity cannot be negative'),

            qty2: Yup.number().default(0).min(0, 'Quantity cannot be negative').optional(),

            qty3: Yup.number().default(0).min(0, 'Quantity cannot be negative').optional(),

            amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

            ratePer: Yup.number().min(0, 'Rate per cannot be negative'),

            uomNoForRate: Yup.number()
               .integer('UOM number must be a whole number')
               .min(0, 'UOM number cannot be negative'),
         }),
      ),
});

const invoiceType = 'purchase';
const PurchaseInvoiceForm = () => {
   const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();
   const {
      isOpen: isOpenIssueToMillModal,
      onOpen: onOpenIssueToMillModal,
      onClose: onCloseIssueToMillModal,
   } = useDisclosure();
   const { isOpen: isOpenTakaModal, onOpen: onOpenTakaModal, onClose: onCloseTakaModal } = useDisclosure();
   const { isOpen: isOpenVerifyModal, onOpen: onOpenVerifyModal, onClose: onCloseVerifyModal } = useDisclosure();
   const { isOpen: isOpenAdjustedDocs, onOpen: onOpenAdjustedDocs, onClose: onCloseAdjustedDocs } = useDisclosure();
   const { isOpen: isOpenSerialhistory, onOpen: onOpenSerialhistory, onClose: onCloseSerialhistory } = useDisclosure();
   const {
      isOpen: isOpenTakaDetailModal,
      onOpen: onOpenTakaDetailModal,
      onClose: onCloseTakaDetailModal,
   } = useDisclosure();
   const {
      isOpen: isOpenTakaDetailChallanModal,
      onOpen: onOpenTakaDetailChallanModal,
      onClose: onCloseTakaDetailChallanModal,
   } = useDisclosure();
   const {
      isOpen: isOpenPrintFormatModal,
      onOpen: onOpenPrintFormatModal,
      onClose: onClosePrintFormatModal,
   } = useDisclosure();
   const { lastPurchaseDaybook, setSelectedDaybookId: setDaybookId } = usePurchaseLastDaybook();
   const { user } = useUser();
   const { companyList, company } = useGlobal();
   // const { items: itemData } = useItem();
   const itemData = useSelector((state) => state.item?.list);

   const { accounts: accountData, incomeAccounts } = useAccount();
   const { purchaseDaybooks: daybookData, paymentDaybooks: daybookPaymentData } = useDaybook();

   const userType = localStorage.getItem('businessTypes');

   // all Selector
   const billTermData = useSelector((state) => state.billTerm?.list);
   const salesInvoice = useSelector((state) => state.purchaseInvoice?.single);
   const stocks = useSelector((state) => state?.salesLineDetail?.stocks);
   const warehouse = useSelector((state) => state?.warehouse?.list);
   const selectedDaybook = useSelector((state) => state.daybook.single);
   const glGroup = useSelector((state) => state.glGroup?.ledger || []);
   const warehouseList = useSelector((state) => state.warehouse.list);
   const companyData = company;
   const targetGlGroup = glGroup.find((group) => group.code === 'E');
   const prints = useSelector((state) => state.setupPrint.list);
   const adjustedDocs = useSelector((state) => state?.sales?.adjusted);
   const issueDocument = useSelector((state) => state?.issue?.issueDocument);
   const serialWiseHistory = useSelector((state) => state?.salesLineDetail?.serialhistory);
   const salesManList = useSelector((state) => state.users.users || []);
   const pendingReceive = useSelector((state) => state.receiveInventory.getPendingReceiveInventories ?? []);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const orderDocument = useSelector((state) => state?.purchaseChallan?.orderDocument);
   const challanDocument = useSelector((state) => state?.purchaseChallan?.challanDocument);
   const millIssueDocument = useSelector((state) => state?.issueInventory?.millPendingIssue || []);

   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyIdWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   const [data, setData] = useState([]);
   const [orderDoc, setOrderDoc] = useState([]);
   const [challanDoc, setChallanDoc] = useState([]);
   const [invoiceImages, setInvoiceImages] = useState([]);
   const [selectedItem, setSelectedItem] = useState(null);
   const [selectedDaybookData, setSelectedDaybookData] = useState(null);
   const [filedDisabled, setFiledDisabled] = useState(false);

   const initialLineItem = useMemo(() => {
      return {
         typeOfSupply: 1,
         headerId: 1,
         gst: 0,
         netGst: 0,
         gstAmount: 0,
         itemId: null,
         lineNumber: 1,
         itemRate: 0,
         amount: 0,
         netAmount: 0,
         taxableAmount: 0,
         ratePer: 0,
         uomNoForRate: 0,
         salesprice1: 0,
         salesprice2: 0,
         salesprice3: 0,
         qty1: 0,
         qty2: 0,
         qty3: 0,
         hsnData: company?.hsndata,
         sacData: company?.sacdata,
         ratio: null,

         addLess1Percent: 0,
         addLess1Amount: 0,
         addLess2Percent: 0,
         addLess2Amount: 0,
         addLess3Percent: 0,
         addLess3Amount: 0,

         stock: [],
         takaDetails: [],
         unit: null,
         qUnitId1: null,
         qUnitId2: null,
         qUnitId3: null,

         issueLineId: null,
         pcliId: null,
         poliId: null,
         subHSNId: null,
         warehouseId: null,
         isDeleted: false,
         notes: '',
         remarks: '',
         gstWithRate: null,
         lotNumber: null,
         itemScreenId: null,
      };
   }, [company?.hsndata, company?.sacdata]);

   const [errors, setErrors] = useState({});
   const [billTerms, setBillTerms] = useState([]);
   const [stockList, setStockList] = useState([]);
   const [selectedStocks, setSelectedStocks] = useState([]);
   const [deleteLineItemId, setDeleteLineItemId] = useState(null);
   const [deleteLineItemIdx, setDeleteLineItemIdx] = useState(null);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [lastItemId, setLastItemId] = useState(null);
   const [currentIndex, setCurrentIndex] = useState(null);
   const [isSameState, setIsSameState] = useState(null);
   const [paymentData, setPaymentData] = useState([]);
   const [voucher, setVoucher] = useState(null);
   const [itemStocks, setItemStocks] = useState([]);
   const [isLoading, setIsLoading] = useState(false);
   const [isPageLoading, setIsPageLoading] = useState(true);
   const [issuedDoc, setIssuedDoc] = useState([]);
   const [millIssueDoc, setMillIssueDoc] = useState([])
   const [currentTakaDetails, setCurrentTakaDetails] = useState([]);
   const [issueData, setIssueData] = useState({});
   const [takaDetails, setTakaDetails] = useState([]);
   const [selectedTakaDetails, setSelectedTakaDetails] = useState([]);
   const [originalPrefix, setOriginalPrefix] = useState('');
   const [originalPostFix, setOriginalPostFix] = useState('');
   const { id } = useParams();
   const [row, setRow] = useState({
      header: {
         daybookId: lastPurchaseDaybook?.daybookId || '',
         docno: '',
         transactionAt: new Date().toISOString().split('T')[0],
         prefix: '',
         postFix: '',
         companyId: '',
         accountId: '',
         brokerId: '',
         basicAmount: 0,
         additionAmount: '',
         deductionAmount: '',
         netAmount: 0,
         dueDays: 0,
         dueAt: new Date().toISOString().split('T')[0],
         billtoStateId: null,
         shiptoStateId: null,
         warehouseId: null,
         partyNo: '',
         partyDate: new Date().toISOString().split('T')[0],
         notes: '',
         representativeId: user?.id,
         incomeId: null,
         tdsRate: null,
         tdsAmount: null,
      },
      lineItem: [initialLineItem],
   });
   const toast = useToast();
   const dispatch = useDispatch();
   const textColor = useColorModeValue('gray.800', 'white');
   const navigate = useNavigate();
   const { businessTypes } = useBusinessType();

   const {
      totals,
      handleQtyChange,
      handleRateChange,
      handleDiscountChange,
      setTotalBillTermAmount,
      setBillTerm,
      finalNetAmount,
      handleItemChange,
      handleUnitChange,
   } = useCalculateTaxAmount({
      row,
      setRow,
      setBillTerms,
      invoiceType,
   });

   // get value in local storage
   const accountId = localStorage.getItem('accountId');
   const daybookId = localStorage.getItem('daybook');

   const lastClick = useRef(0);

   const daybookRef = useRef(null);
   const docNoRef = useRef(null);
   const transactionAtRef = useRef(null);
   const accountRef = useRef(null);
   const incomeRef = useRef(null);
   const brokerRef = useRef(null);
   const partyBillNoRef = useRef(null);
   const partyDateRef = useRef(null);
   const dueDaysRef = useRef(null);
   const dueDateRef = useRef(null);
   const tdsRateRef = useRef(null);
   const tdsAmountRef = useRef(null);
   const notesRef = useRef(null);
   const wareHouseRef = useRef(null);
   const issueDocRef = useRef(null);
   const millIssueDocRef = useRef(null);
   const supplierRef = useRef(null);
   const submitRef = useRef(null);
   const closeRef = useRef(null);
   const lineItemNotesRef = useRef(null);
   const lineItemRemarkRef = useRef(null);
   const orderDocRef = useRef(null);
   const challanDocRef = useRef(null);
   const warehouseRef = useRef([]);
   const itemRefs = useRef([]);
   const qty1Refs = useRef([]);
   const qty2Ref = useRef([]);
   const qty3Ref = useRef([]);
   const rateRefs = useRef([]);
   const gstRateRefs = useRef([]);
   const gstTaxableRefs = useRef([]);
   const percentageRefs = useRef([]);
   const amountRefs = useRef([]);
   const subamountRefs = useRef([]);
   const paymentRefs = useRef([]);
   const itemScreenIdRefs = useRef([]);
   const lotNumberRefs = useRef([]);
   const issueDocRefs = useRef([]);
   const prefixRef = useRef(null);
   const suffixRef = useRef(null);
   const refs = {
      warehouseRef,
      itemRefs,
      qty1Refs,
      qty2Ref,
      qty3Ref,
      rateRefs,
      percentageRefs,
      subamountRefs,
      amountRefs,
      dueDaysRef,
      issueDocRefs,
      lineItemNotesRef,
      lineItemRemarkRef,
      gstRateRefs,
      gstTaxableRefs,
      itemScreenIdRefs,
      lotNumberRefs,
   };

   const daybook = useMemo(() => {
      return daybookData?.filter((item) => item.type === 11).find((daybook) => daybook.id === row.header.daybookId);
   }, [daybookData, row.header.daybookId]);

   const pendingPayment = useMemo(() => {
      let badgeColor = 'blue.400';
      let borderColor = 'blue.400';

      if (salesInvoice?.pendingstatus === 'FULL PENDING') {
         badgeColor = 'orange.400';
         borderColor = 'orange.400';
      } else if (salesInvoice?.pendingstatus === 'CLEAR') {
         badgeColor = 'green.400';
         borderColor = 'green.400';
      } else if (salesInvoice?.pendingstatus === 'PART PENDING') {
         badgeColor = 'blue.400';
         borderColor = 'blue.400';
      }

      return { badgeColor, borderColor };
   }, [salesInvoice?.pendingstatus]);

   const account = useMemo(() => {
      return accountData.find((account) => account.id === row.header.accountId);
   }, [accountData, row.header.accountId]);

   const incomeacc = useMemo(() => {
      return incomeAccounts.find((account) => account.id === row.header.incomeId);
   }, [incomeAccounts, row.header.incomeId]);

   const daybookacc = useMemo(() => {
      return accountData.find((account) => account.id === daybook?.accountId);
   }, [accountData, daybook?.accountId]);

   const vouchers = useMemo(() => salesInvoice?.vouchers ?? [], [salesInvoice?.vouchers]);

   const accTds = account && account?.tdsApplicable && account?.tdsAccountId ? true : false;
   const daybookTds = (daybook && row.header.incomeId && incomeacc?.tdsApplicable && incomeacc?.tdsAccountId)
      ? true
      : (daybook && daybook?.accountId && daybookacc?.tdsApplicable && daybookacc?.tdsAccountId)
         ? true
         : false;

   const showTds = accTds && daybookTds;

   useEffect(() => {
      if (showTds) {
         const TDSApplyOn = daybook?.TDSApplyOn;
         const TDSRate = row.header?.tdsRate ? row.header?.tdsRate : account?.tdsRate;
         if (TDSRate && TDSApplyOn !== null && TDSRate > 0) {
            setRow(prev => {
               const netAmount = Number(finalNetAmount ?? prev.header?.netAmount ?? 0);
               const taxableAmount = Number(totals.taxableAmount ?? prev.header?.taxableAmount ?? 0);

               // decide base amount
               const baseAmount = TDSApplyOn === 0 ? netAmount : taxableAmount;

               // calculate TDS amount
               const tdsAmount = (baseAmount * TDSRate) / 100;

               return {
                  ...prev,
                  header: {
                     ...prev.header,
                     tdsRate: TDSRate,
                     tdsAmount: Number(tdsAmount),
                  },
               };
            });
         }
      } else {
         setRow(prev => ({
            ...prev,
            header: {
               ...prev.header,
               tdsRate: null,
               tdsAmount: null,
            },
         }));
      }
   }, [setRow, showTds, row.header.accountId]);

   useEffect(() => {
      if (showTds) {
         const TDSApplyOn = daybook?.TDSApplyOn;
         const TDSRate = row.header?.tdsRate ? row.header?.tdsRate : account?.tdsRate;
         if (TDSRate && TDSApplyOn !== null && TDSRate > 0) {
            setRow(prev => {
               const netAmount = Number(finalNetAmount || 0);
               const taxableAmount = Number(totals.taxableAmount || 0);

               // decide base amount
               const baseAmount = TDSApplyOn === 0 ? netAmount : taxableAmount;

               // calculate TDS amount
               const tdsAmount = (baseAmount * TDSRate) / 100;

               return {
                  ...prev,
                  header: {
                     ...prev.header,
                     tdsAmount: Number(tdsAmount),
                  },
               };
            });
         }
      }
   }, [setRow, row.header.netAmount, row.header?.tdsRate, totals.taxableAmount, finalNetAmount]);

   const warehouseMap = useMemo(() => {
      const map = {};
      warehouseList.forEach((warehouse) => {
         map[warehouse.id] = warehouse.warehouseName || warehouse.name;
      });
      return map;
   }, [warehouseList]);

   useEffect(() => {
      if (user && user.isExpired) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      if (user?.loginhistory.companyId) {
         dispatch(
            getItem({
               companyId: user?.loginhistory.companyId,
               sortBy: 'name',
               sortOrder: 'asc',
               ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, shouldSendCompanyIdItem, user?.loginhistory.companyId]);

   useEffect(() => {
      const purchaseInvoiceRight = Array.isArray(user?.userRights)
         ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.purchaseinvoice
         : null;

      if (user && user?.isAdmin !== true) {
         if (window.location.pathname.includes('purchase/invoice/add') && purchaseInvoiceRight) {
            if (purchaseInvoiceRight?.add !== true) {
               window.history.back();
            }
         } else if (window.location.pathname.includes('purchase/invoice/edit') && purchaseInvoiceRight) {
            if (purchaseInvoiceRight?.edit !== true) {
               window.history.back();
            }
         }
      }
   }, [user]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            if (!isLoading) {
               handleAskToVerifyCustomer();
            }
            return false;
         }
      };

      document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
      window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

      return () => {
         document.removeEventListener('keydown', handleKeyDown, { capture: true });
         window.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
   }, [row, isLoading]);

   const handleKeyDown = (e, nextRef, preRef) => {
      if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         if (preRef && preRef?.current) {
            preRef?.current?.focus();
         }
      }
   };

   const prepareRowRefs = (count) => {
      warehouseRef.current = Array(count)
         .fill()
         .map((_, i) => warehouseRef.current[i] || createRef());

      itemRefs.current = Array(count)
         .fill()
         .map((_, i) => itemRefs.current[i] || createRef());

      qty1Refs.current = Array(count)
         .fill()
         .map((_, i) => qty1Refs.current[i] || createRef());

      rateRefs.current = Array(count)
         .fill()
         .map((_, i) => rateRefs.current[i] || createRef());

      gstRateRefs.current = Array(count)
         .fill()
         .map((_, i) => gstRateRefs.current[i] || createRef());

      gstTaxableRefs.current = Array(count)
         .fill()
         .map((_, i) => gstTaxableRefs.current[i] || createRef());
      lineItemNotesRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemNotesRef?.current?.[i] || createRef());

      lineItemRemarkRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemRemarkRef?.current?.[i] || createRef());

      itemScreenIdRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => itemScreenIdRefs?.current?.[i] || createRef());

      lotNumberRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => lotNumberRefs?.current?.[i] || createRef());
   };

   const prepareBillTermRowRefs = (count) => {
      percentageRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => percentageRefs.current[i] || createRef());

      amountRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => amountRefs.current[i] || createRef());
   };

   const preparePaymentRowRefs = (count) => {
      paymentRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => paymentRefs.current[i] || createRef());
   };

   const validateForm = useCallback(async () => {
      try {
         const normalizedLineItems =
            row?.lineItem?.map((item) => ({
               ...item,
               qty2: item.qty2 ?? 0,
               qty3: item.qty3 ?? 0,
            })) ?? [];

         const updatedRow = {
            ...row,
            lineItem: normalizedLineItems,
         };
         await validationSchema.validate(updatedRow, { abortEarly: false });
         setErrors({});
         return true;
      } catch (error) {
         if (error instanceof Yup.ValidationError) {
            const newErrors = {};
            error.inner.forEach((err) => {
               newErrors[err.path] = err.message;
            });
            setErrors(newErrors);
            return false;
         }
         return false;
      }
   }, [row]);

   const handleStockModalOnClick = useCallback(
      async (index, type) => {
         const selectedItemData = row.lineItem[Number(index)];
         const item = itemData.find((item) => item?.id?.toString() === selectedItemData?.itemId?.toString());
         if (user?.loginhistory?.companyId && businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
            await dispatch(
               getStock({
                  itemId: Number(selectedItemData?.itemId),
                  companyId: Number(user?.loginhistory?.companyId),
                  type: 'purchase',
               }),
            );
         }

         if (item && item.itemdetailtype === 1) {
            setLastItemId(selectedItemData.itemId);
            setStockList((prev) => prev.concat(selectedItemData?.stock));
            setItemStocks(
               selectedItemData?.stock?.map((item) => ({
                  id: item.id,
                  note1: item.note1,
                  serialNo: item?.serialNo,
                  serialNo2: item?.serialNo2,
                  processStatus: item?.processStatus,
                  barcode: item.barcode,
                  isOld: item.isOld,
                  isBox: item.isBox,
                  isBill: item.isBill,
                  isKit: item.isKit,
                  itemId: selectedItemData.itemId,
                  itemName: selectedItemData.itemName,
                  warehouseId: item?.warehouseId,
               })),
            );
            setCurrentIndex(index);
            onOpenModal();
         } else if (type === 'purchaseinvoice') {
            setLastItemId(selectedItemData.itemId);
            setStockList((prev) => prev.concat(selectedItemData?.stock));
            setItemStocks(
               selectedItemData?.stock?.map((item) => ({
                  note1: item.note1,
                  serialNo: item?.serialNo,
                  serialNo2: item?.serialNo2,
                  processStatus: item?.processStatus,
                  warehouseId: item?.warehouseId,
                  barcode: item.barcode,
                  isOld: item.isOld,
                  isBox: item.isBox,
                  isBill: item.isBill,
                  isKit: item.isKit,
                  itemId: selectedItemData.itemId,
                  itemName: selectedItemData.itemName,
               })),
            );
            setCurrentIndex(index);
            onOpenModal();
         }
         if (
            daybook &&
            daybook.getLineDetail &&
            selectedItemData.itemId &&
            selectedItemData.itemId > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            setCurrentIndex(index);
            setCurrentTakaDetails(row.lineItem[index]?.takaDetails || []);

            const itemData = row.lineItem[Number(index)];
            if (itemData.issueLineId && itemData.issueLineId > 0) {
               setSelectedTakaDetails(itemData?.takaDetails);
               onOpenTakaDetailModal();
            }
            else if (daybook?.getLineDetail && itemData.pcliId && daybook?.challanFieldRegion === 0) {
               if (Array.isArray(itemData.takaDetails) && Array.from(itemData?.takaDetails).length > 0) {
                  setTakaDetails(itemData.takaDetails.map((i) => ({ ...i, isSelected: true, id: i.id })));
                  onOpenTakaDetailChallanModal();
               } else {
                  onOpenTakaModal();
               }
            }
            else {
               setCurrentTakaDetails(row.lineItem[index]?.takaDetails || []);
               onOpenTakaModal();
            }
         }
      },
      [
         businessTypes?.businessType,
         daybook,
         dispatch,
         itemData,
         onOpenModal,
         onOpenTakaDetailModal,
         onOpenTakaModal,
         row.lineItem,
         user?.loginhistory?.companyId,
      ],
   );

   const handleDaybook = async (name, value) => {
      const newRow = { ...row };
      setDaybookId(Number(value));
      await dispatch(getBillTerm({
         daybookId: Number(value),
         ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
      }));

      const selectedDb = daybookData?.find((db) => db.id === Number(value));

      // ✅ Add mode AND Edit mode dono mein prefix/suffix update
      if (selectedDb) {
         const sep = selectedDb.separator || '';
         const cleanPrefix = sep
            ? (selectedDb.prefix || '').replace(new RegExp(sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', ''), '')
            : (selectedDb.prefix || '');
         const cleanSuffix = sep
            ? (selectedDb.suffix || '').replace(new RegExp('^' + sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ''), '')
            : (selectedDb.suffix || '');
         newRow.header.prefix = cleanPrefix;
         newRow.header.postFix = cleanSuffix;
         setOriginalPrefix(cleanPrefix);
         setOriginalPostFix(cleanSuffix);
      }

      newRow.header[name] = value;
      setRow({ ...newRow });
      setErrors((prev) => {
         const obj = { ...prev };
         const fullName = `header.${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleAccount = async (name, value) => {
      if (name === 'accountId' && value !== null) {
         const newRow = { ...row };
         // const id = value?.id ? value.id : value;
         newRow.header[name] = value?.id ? value.id : value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.accountId'];
            return obj;
         });
         if (daybook && daybook?.issuedaybookid && value && businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
            await dispatch(getIssuesDocument({ accountId: value, companyId: user?.loginhistory?.companyId }));
            setIssuedDoc([]);
            if (id) {
               if (value === salesInvoice?.accountId) {
                  setRow((prev) => ({
                     ...prev,
                     lineItem: [...prev?.lineItem?.filter((item) => item.itemId && item.id).map((item) => ({ ...item, isDeleted: false }))],
                  }));
               } else {
                  setRow((prev) => ({
                     ...prev,
                     lineItem: [...prev?.lineItem?.filter((item) => item.itemId && item.id).map((item) => ({ ...item, isDeleted: true })), initialLineItem],
                  }));
               }
            } else {
               setRow((prev) => ({
                  ...prev,
                  lineItem: [initialLineItem],
               }));
            }
         }
         if (businessTypes?.businessType?.toUpperCase() === 'TEXTILE' && daybook?.isMillReceive && daybook?.issuedaybookid) {
            await dispatch(getMillPendingIssue({
               companyId: user?.loginhistory?.companyId,
               ...(value && { accountId: Number(value) }),
               ...(daybook?.issuedaybookid && { daybookId: daybook?.issuedaybookid }),
            }))
         }
         if (daybook && daybook?.orderFieldRegion === 0 && value && businessTypes?.businessType?.toUpperCase() !== 'MOBILE') {
            await dispatch(getOrderDocument({
               accountId: value,
               ...(daybook?.orderdaybookid && { daybookId: daybook?.orderdaybookid }),
               ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
               ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
            }));
         }
         if (daybook && daybook?.challanFieldRegion === 0 && value && businessTypes?.businessType?.toUpperCase() !== 'MOBILE') {
            await dispatch(getChallanDocument({
               accountId: value,
               ...(daybook?.challandaybookid && { daybookId: daybook?.challandaybookid }),
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
               ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
            }));
         }
         if (value === '' && daybook && daybook?.orderFieldRegion === 0 && businessTypes?.businessType?.toUpperCase() !== 'MOBILE') {
            setOrderDoc([]);
            await dispatch(getOrderDocument({
               ...(daybook?.orderdaybookid && { daybookId: daybook?.orderdaybookid }),
               ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
               ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
            }));
            setRow((prev) => ({
               ...prev,
               lineItem: [initialLineItem],
            }));
         }
         if (value === '' && daybook && daybook?.challanFieldRegion === 0 && businessTypes?.businessType?.toUpperCase() !== 'MOBILE') {
            setChallanDoc([]);
            await dispatch(getChallanDocument({
               ...(daybook?.challandaybookid && { daybookId: daybook?.challandaybookid }),
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
               ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
            }));
            setRow((prev) => ({
               ...prev,
               lineItem: [initialLineItem],
            }));
         }
         if (value === '' && daybook && daybook?.issuedaybookid && businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
            // const lineItem = {
            //    typeOfSupply: 1,
            //    headerId: 1,
            //    gst: 0,
            //    netGst: 0,
            //    gstAmount: 0,
            //    itemId: null,
            //    lineNumber: 1,
            //    itemRate: 0,
            //    amount: 0,
            //    netAmount: 0,
            //    taxableAmount: 0,
            //    ratePer: 0,
            //    uomNoForRate: 0,
            //    salesprice1: 0,
            //    salesprice2: 0,
            //    salesprice3: 0,
            //    qty1: 0,
            //    qty2: 0,
            //    qty3: 0,
            //    hsnData: company?.hsndata,
            //    sacData: company?.sacdata,
            //    ratio: null,
            //    addLess1Percent: 0,
            //    addLess1Amount: 0,
            //    addLess2Percent: 0,
            //    addLess2Amount: 0,
            //    addLess3Percent: 0,
            //    addLess3Amount: 0,
            //    stock: [],
            //    takaDetails: [],
            //    unit: null,
            //    qUnitId1: null,
            //    qUnitId2: null,
            //    qUnitId3: null,
            //    issueLineId: null,
            //    subHSNId: null,
            //    warehouseId: null,
            //    isDeleted: false,
            //    notes: '',
            //    remarks: '',
            // };
            if (id) {
               console.log("run with id", id, row);
               setRow((prev) => ({
                  ...prev,
                  lineItem: [...prev?.lineItem?.filter((item) => item.itemId && item.id).map((item) => ({ ...item, isDeleted: true })), initialLineItem],
               }));
            } else {
               console.log("run without id", id, salesInvoice);
               setRow((prev) => ({
                  ...prev,
                  lineItem: [initialLineItem],
               }));
            }
            setIssuedDoc([]);
            await dispatch(getIssuesDocument({
               companyId: user?.loginhistory?.companyId,
            }));
         }
         const newaccount = accountData.find((acc) => acc.id === id);

         if (newaccount) {
            const getGstRateFromLineItem = (lineItem) => {
               let hsn = null;

               if (lineItem?.typeOfSupply === 1) {
                  if (lineItem?.hsnData?.subHsn.length === 1) {
                     hsn = lineItem?.hsnData?.subHsn[0];
                  } else {
                     hsn = lineItem?.hsnData?.subHsn.find(
                        (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                     );
                  }
               }

               if (lineItem?.typeOfSupply === 2) {
                  if (lineItem?.sacData?.subHsn.length === 1) {
                     hsn = lineItem?.sacData?.subHsn[0];
                  } else {
                     hsn = lineItem?.sacData?.subHsn.find(
                        (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                     );
                  }
               }

               return hsn?.gst || 0;
            };

            const updatedLineItems = row.lineItem.map((item) => {
               if (!item.itemId) return { ...item };

               const gstRate = newaccount.gstRegNo ? getGstRateFromLineItem(item) : 0;
               const gstAmount = item.itemRate * item.qty1 * (gstRate / 100);

               return {
                  ...item,
                  gstAmount: gstAmount,
                  gst: gstRate,
               };
            });
            setRow((prev) => ({
               ...prev,
               lineItem: updatedLineItems,
            }));
         }
      }
      if (name === 'accountId' && value === null) {
         const newRow = { ...row };
         const id = value?.id ? value.id : value;
         newRow.header[name] = id;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.accountId'];
            return obj;
         });
      }

      if (name === 'warehouseId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         newRow.lineItem = newRow.lineItem.map((item) => ({
            ...item,
            [name]: value,
            stock: Array.isArray(item.stock)
               ? item.stock.map((stockItem) => ({
                  ...stockItem,
                  [name]: value,
               }))
               : [], // fallback if stock is not array
         }));
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.brokerId'];
            return obj;
         });
      }

      if (name === 'brokerId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.brokerId'];
            return obj;
         });
      }

      if (name === 'representativeId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.representativeId'];
            return obj;
         });
      }

      if (name === 'incomeId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.incomeId'];
            return obj;
         });
      }
   };

   const handleStockModal = useCallback(
      (itemId, index) => {
         const selectedItem = itemData.find((item) => item.id.toString() === itemId.toString());
         if (selectedItem && selectedItem.itemdetailtype === 1) {
            setCurrentIndex(index);
            onOpenModal();
         }

         if (
            daybook &&
            daybook?.getLineDetail &&
            selectedItem &&
            selectedItem?.id > 0 &&
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
         ) {
            const itemData = row.lineItem[Number(index)];
            if (itemData?.issueLineId && daybook?.getLineDetail && daybook?.isMillReceive) {
               const purchaseDocument = pendingReceive.find((x) => x.item_id === itemId);
               const takaDetails = itemData?.takaDetails?.map((i) => {
                  return {
                     ...i,
                  };
               });
               setSelectedTakaDetails(takaDetails);
               setTakaDetails(takaDetails);
               onOpenTakaDetailModal();
            }
            else if (daybook?.getLineDetail && itemData.pcliId && daybook?.challanFieldRegion === 0 && daybook?.challandaybookid) {
               const selectedTakaDetails = itemData?.takaDetails?.map((i) => {
                  return {
                     ...i,
                     quantity3: i.quantity3,
                     itenName: i.itemName,
                     itemId: i.itemId,
                     purchaseLineItemId: i.purchaseLineItemId,
                     pcldId: i.pcldId,
                     isSelected: i.isSelected || true,
                  };
               })
               const std = Array.isArray(selectedTakaDetails) && selectedTakaDetails.length > 0 ? selectedTakaDetails : [];
               setTakaDetails(std);
               onOpenTakaDetailChallanModal();
            }
            else {
               onOpenTakaModal();
            }
         }
      },
      [
         businessTypes?.businessType,
         daybook,
         itemData,
         onOpenModal,
         onOpenTakaDetailModal,
         onOpenTakaDetailChallanModal,
         onOpenTakaModal,
         pendingReceive,
         row.lineItem,
      ],
   );

   const handleSerialHistory = (item) => {
      setSelectedItem(item);
      dispatch(getSerialWiseHistory({ companyIds: user?.loginhistory?.companyId, serialNo: item.serialNo }));
   };

   const handleWarehouseId = useCallback(
      (warehouseId) => {
         const warehouseIn =
            daybook?.warehouseInId === 1 || companyData?.setting?.warehouseInPurchase === 1
               ? [1]
               : daybook?.warehouseInId === 2 || companyData?.setting?.warehouseInPurchase === 2
                  ? [1, 2]
                  : [1, 2, 3];
         if (companyData?.setting?.warehouseWishStock) {
            if (
               (warehouseIn.includes(daybook?.warehouseInId) ||
                  warehouseIn.includes(companyData?.setting?.warehouseInPurchase)) &&
               warehouseId &&
               warehouseId > 0
            )
               return warehouseId;
            if (warehouseIn.includes(daybook?.warehouseInId) && daybook?.wareHouseId && daybook?.wareHouseId > 0) {
               return daybook?.wareHouseId;
            }
            if (
               warehouseIn.includes(companyData?.setting?.warehouseInPurchase) &&
               companyData?.setting?.warehouseId &&
               companyData?.setting?.warehouseId > 0
            ) {
               return companyData?.setting?.warehouseId;
            }
         }
         return 1;
      },
      [companyData?.setting?.warehouseWishStock, daybook?.warehouseInId, daybook?.wareHouseId],
   );

   useEffect(() => {
      if (selectedItem && serialWiseHistory) {
         const historyForItem = serialWiseHistory?.flatMap((data) =>
            data?.items
               ?.filter((subdata) => subdata.item_id === selectedItem.itemId)
               ?.flatMap((subdata) => subdata?.transactions),
         );
         setData(historyForItem);
         onOpenSerialhistory();
      }
   }, [serialWiseHistory, selectedItem]);

   useEffect(() => {
      if (!id) {
         const selectedAccount = accountData.find((ac) => ac.id === row.header.accountId);
         const selectedDaybook = daybookData.find((db) => db.id === row.header.daybookId);

         if (selectedAccount && selectedAccount?.defaultDueDays) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: selectedAccount?.defaultDueDays,
                  dueAt: moment().add(Number(selectedAccount?.defaultDueDays), 'days').format('YYYY-MM-DD'),
               },
            }));
         } else if (selectedDaybook && selectedDaybook?.dueDays) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: selectedDaybook?.dueDays,
                  dueAt: moment().add(Number(selectedDaybook?.dueDays), 'days').format('YYYY-MM-DD'),
               },
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: 0,
                  dueAt: moment().add(Number(0), 'days').format('YYYY-MM-DD'),
               },
            }));
         }
      }
   }, [row.header.daybookId, row.header.accountId]);

   const handleAdjustedDocs = () => {
      dispatch(
         getAdjustedDocs({
            companyId: user?.loginhistory?.companyId,
            spId: id,
            daybookId: row.header.daybookId,
            accountId: row.header.accountId,
            type: 'PURCHASE',
         }),
      );
      onOpenAdjustedDocs();
      const selectedDaybookData = daybookData.filter((item) => item.id === row.header.daybookId);
      setSelectedDaybookData(selectedDaybookData);
   };

   const handleItemPrice = useCallback(
      async (itemId, type) => {
         if (daybook?.partyItemWiseLastRate || daybook?.itemWiseLastRate) {
            const params = { itemId, companyId: company?.id, type };
            if (daybook?.partyItemWiseLastRate) {
               params.accountId = account?.id;
            }
            const res = await dispatch(getItemPrice(params));
            return res?.data?.itemPrice ?? '';
         }
      },
      [account?.id, company?.id, daybook?.itemWiseLastRate, daybook?.partyItemWiseLastRate, dispatch],
   );

   const handleOnChange = async (header, name, value, idx) => {
      const newRow = { ...row };
      const lineItem = newRow.lineItem[idx];

      if (['qty1', 'qty2', 'qty3'].includes(name)) {
         handleQtyChange(name, value, idx);
      }
      if (name === 'itemRate') {
         const gstRate = getGstRate(value, newRow, header, idx);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange(name, value, idx);
      }
      if (name === 'gstWithRate') {
         const gstRate = Number(value || 0);
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const itemRate = gstRate / (1 + gstPercent / 100);
         handleRateChange('itemRate', Number(itemRate || 0)?.toFixed(2), idx);
      }
      if (name === 'amount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (name === 'taxableAmount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (['addLess1Percent', 'addLess2Percent', 'addLess3Percent'].includes(name)) {
         handleDiscountChange(name, value, idx);
      }

      if (name === 'unit') {
         handleUnitChange(value, idx);
      }

      if (name === 'warehouseId') {
         newRow[header][idx][name] = value;
      }

      if (name === 'issueLineId') {
         if (businessTypes?.businessType?.toUpperCase() === 'TEXTILE') {
            setCurrentIndex(idx);
            const purchaseDocument = pendingReceive.find((x) => x.item_id === Number(value));
            handleItemChange('itemId', purchaseDocument?.item_id, idx, 'purchaseinvoice');
            if (purchaseDocument) {
               if (daybook && daybook.getLineDetail === false) {
                  const qty1 = Number(purchaseDocument?.balance_receive_qty1 ?? 0);
                  const qty3 = Number(purchaseDocument?.balance_receive_qty3_taka_meters ?? 0);

                  handleQtyChange('qty1', qty1, idx);
                  handleQtyChange('qty3', qty3, idx);
               }

               newRow[header][idx].issueLineId = Number(value);
               newRow[header][idx].itemId = purchaseDocument?.item_id;
               setRow(newRow);
               handleStockModal(purchaseDocument?.item_id, idx);
            }
         }
      }
      if (name === 'itemId') {
         const selectedItem = itemData.find((x) => x.id === Number(value));
         newRow[header][idx].unit = selectedItem?.rateperpurchaseid;
         setCurrentIndex(idx);
         handleQtyChange('qty1', 0, idx);
         handleQtyChange('qty2', 0, idx);
         handleQtyChange('qty3', 0, idx);
         handleRateChange('itemRate', 0, idx);
         handleDiscountChange('addLess1Percent', 0, idx);
         handleDiscountChange('addLess2Percent', 0, idx);
         handleDiscountChange('addLess3Percent', 0, idx);
         handleItemChange(name, value, idx, 'purchaseinvoice');
         if (selectedItem?.purchaseprice) {
            const gstRate = getGstRate(selectedItem?.salesprice1, newRow, header, idx);
            newRow[header][idx].gstWithRate = gstRate;
         }
         const itemPrice = await handleItemPrice(value, 'purchase');
         const rate = getGstRate(itemPrice, newRow, header, idx);
         newRow[header][idx].gstWithRate = rate;
         if (businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
            dispatch(
               getStock({
                  itemId: Number(value),
                  companyId: user?.loginhistory?.companyId,
                  type: 'purchase',
               }),
            );
         }
         // if (daybook?.isMillReceive) {
         //    handleStockModal(value, idx);
         // } else {
         handleStockModalOnClick(idx);
         // }
         setLastItemId(Number(value));
      }

      if (name === 'itemScreenId') {
         // const selectedItem = itemData.find((x) => x.id === Number(value));
         newRow[header][idx].itemScreenId = Number(value);
      }
      if (name === 'lotNumber') {
         newRow[header][idx].lotNumber = Number(value);
      }

      const selectedDaybook = filteredDaybooks.find((item) => item.id === row?.header?.daybookId);
      const selectedAccount = accountData.find((item) => item.id === row?.header?.accountId);
      let subHsn;
      if (company?.setting?.applyGST && selectedDaybook?.applyGst && newRow[header][idx].itemId) {
         if (name === 'typeOfSupply') {
            if (value === 1) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.hsnData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            if (value === 2) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.sacData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }

            const newGSt = selectedAccount?.gstRegNo ? subHsn?.gst : 0;
            const taxRate = parseFloat(newGSt) / 100;
            newRow[header][idx].gst = newGSt ?? 0;
            newRow[header][idx].subHSNId = subHsn?.id ?? 0;
            newRow[header][idx].gstAmount = lineItem.itemRate * lineItem.qty1 * taxRate;
            newRow[header][idx].ratio = subHsn?.ratio ?? null;
         }
      }
      newRow[header][idx][name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}[${idx}].${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleBillTermChange = useCallback(
      (index, values) => {
         setBillTerms((prev) => {
            const newBillTerms = [...prev];
            newBillTerms[index] = {
               ...newBillTerms[index],
               ...values,
            };
            const currentBasicAmount = parseFloat(row.header.basicAmount) || 0;

            let additionTotal = 0;
            let deductionTotal = 0;

            newBillTerms.forEach((term, idx) => {
               const amount = parseFloat(term.amount) || 0;
               const termData = billTermData[idx];

               if (termData?.signname === 'Subtraction') {
                  deductionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Addition') {
                  additionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Both') {
                  if (amount < 0) {
                     deductionTotal += Math.abs(amount);
                  } else {
                     additionTotal += amount;
                  }
               }
            });

            // Calculate net amount based on the basic amount
            const netAmount = currentBasicAmount + additionTotal - deductionTotal;

            let billTerm = additionTotal - deductionTotal;
            let netTotal = totals.netAmount + additionTotal;
            netTotal = netTotal - deductionTotal;
            setBillTerm(billTerm);
            setTotalBillTermAmount(netTotal);

            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  additionAmount: additionTotal.toFixed(2),
                  deductionAmount: deductionTotal.toFixed(2),
                  netAmount: netAmount.toFixed(2),
                  basicAmount: currentBasicAmount.toFixed(2),
               },
            }));

            return newBillTerms;
         });
      },
      [billTermData, row.header.basicAmount, setBillTerm, setTotalBillTermAmount, totals.netAmount],
   );

   const addLineItem = () => {
      setRow((prev) => ({
         ...prev,
         lineItem: [...prev.lineItem, { ...initialLineItem }],
      }));
   };

   const removeLineItem = (index, id) => {


      if (id) {
         Swal.fire({
            title: 'Are you sure?',
            text: `This entry is marked for removal/emptying. Please ensure this entry is saved permanently before proceeding.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
         }).then((result) => {
            if (result.isConfirmed) {
               setRow((prev) => ({
                  ...prev,
                  lineItem: prev.lineItem
                     .map((li, idx) => {
                        if (!li.itemId) return null;
                        return li.id === id ? { ...li, isDeleted: true } : li;
                     })
                     .filter(Boolean),
               }));
            }
         });
      } else {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== index),
         }));
      }
   };

   const handleDelete = () => {
      if (deleteLineItemId) dispatch(deletePurchaseLineItem(deleteLineItemId));
      if (deleteLineItemIdx >= 0) {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== deleteLineItemIdx),
         }));
      }
      setDeleteLineItemId(null);
      setDeleteLineItemIdx(null);
      setDeleteDialogOpen(false);
   };

   const removeStock = useCallback(
      (stock) => {

         const updatedLineItem = row?.lineItem?.map((item, idx) => {
            const selectedItem = itemData.find((i) => i.id === item.itemId);
            const stockData = item.stock.filter((s) => s.serialNo !== stock.serialNo);
            const qty1 = stockData?.length;

            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 === 0) {
               handleQtyChange('qty1', qty1, idx);
               itemRefs.current[idx].focus();
               return { ...item, itemId: '', stock: [], qty1: qty1, itemRate: 0 };
            }
            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 > 0) {
               handleQtyChange('qty1', qty1, idx);
               return { ...item, stock: stockData, qty1: qty1 };
            }

            return item;
         });

         setRow((prev) => ({
            ...prev,
            lineItem: updatedLineItem,
         }));
      },
      [handleQtyChange, row.lineItem, itemData], // Added missing dependencies
   );

   const handleEditValues = useCallback(() => {
      if (id && salesInvoice) {
         const formatDate = (dateString) => {
            if (!dateString || dateString === '') return '';

            try {
               if (typeof dateString === 'string' && dateString.includes('/')) {
                  return moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD');
               }

               const date = moment(dateString);
               return date.isValid() ? date.format('YYYY-MM-DD') : '';
            } catch (error) {
               console.error('Error parsing date:', dateString, error);
               return '';
            }
         };

         setRow({
            header: {
               daybookId: salesInvoice?.daybookId || '',
               docno: salesInvoice?.docno || '',
               transactionAt: formatDate(salesInvoice?.transactionAt),
               dueAt: formatDate(salesInvoice?.dueAt),
               dueDays: salesInvoice?.dueDays || 0,
               accountId: salesInvoice?.accountId || '',
               basicAmount: salesInvoice?.basicAmount || 0,
               netAmount: salesInvoice?.netAmount || 0,
               partyNo: salesInvoice?.partyNo || '',
               partyDate: formatDate(salesInvoice?.partyDate),
               notes: salesInvoice?.notes || '',
               brokerId: salesInvoice?.brokerId || null,
               representativeId: salesInvoice?.representativeId || user?.id,
               warehouseId: salesInvoice?.warehouseId || null,
               incomeId: salesInvoice?.incomeId || null,
               tdsRate: salesInvoice.tdsRate,
               tdsAmount: salesInvoice.tdsAmount,
               prefix: (() => {
                  const db = daybookData?.find((d) => d.id === salesInvoice.daybookId);
                  const sep = db?.separator || '';
                  if (!sep) return salesInvoice.prefix || '';
                  const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                  return (salesInvoice.prefix || '').replace(new RegExp(escaped + '$', ''), '');
               })(),
               postFix: (() => {
                  const db = daybookData?.find((d) => d.id === salesInvoice.daybookId);
                  const sep = db?.separator || '';
                  if (!sep) return salesInvoice.postFix || '';
                  const escaped = sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                  return (salesInvoice.postFix || '').replace(new RegExp('^' + escaped, ''), '');
               })(),
            },
            lineItem:
               salesInvoice?.lineitems?.map((item, index) => {
                  const isDisabled = (item?.minQty1 > 0 || item?.minQty2 > 0 || item?.minQty3 > 0);
                  const processStatus = [
                     ...new Set(
                        item?.purchaseLineDetail
                           ?.map((a) => a.processStatus)
                           ?.filter(Boolean)
                     )
                  ];
                  setFiledDisabled(businessTypes?.businessType?.toUpperCase() === 'TEXTILE' ? isDisabled : processStatus?.includes("PURCHASE_RETURN"));
                  return {
                     ...item,
                     itemRate: item.itemRate?.toString(),
                     amount: item.amount,
                     typeOfSupply: Number(item.typeOfSupply),
                     netAmount: item.netAmount,
                     taxableAmount: item.taxableAmount,
                     ratio: item.ratio,
                     addLess1Percent: item.addLess1Percent,
                     addLess1Amount: item.addLess1Amount,
                     addLess2Percent: item.addLess2Percent,
                     addLess2Amount: item.addLess2Amount,
                     addLess3Percent: item.addLess3Percent,
                     addLess3Amount: item.addLess3Amount,
                     gst: item.gstPercent,
                     unit: item.ratePer,
                     isDeleted: false,
                     isDisabled: isDisabled ? true : false,
                     notes: item.notes ? item.notes : '',
                     remarks: item.remarks ? item.remarks : '',
                     gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                     isDisItem: processStatus?.includes("SALES") || processStatus?.includes("ISSUE"),
                     isDisItemRate: processStatus?.includes("PURCHASE_RETURN"),
                     processStatus: processStatus,
                     stock: item?.purchaseLineDetail
                        ?.filter((a) => a.serialNo !== '' && a.serialNo !== null && a.serialNo !== undefined)
                        .map((stock) => {
                           const {
                              id,
                              isOld,
                              isBox,
                              isBill,
                              isKit,
                              itemId,
                              barcode,
                              itemName,
                              serialNo,
                              quantity1,
                              quantity2,
                              quantity3,
                              serialNo2,
                              specifications,
                              lineItemId,
                              warehouseId,
                              warehouseName,
                              issueLineDetailId,
                              processStatus,
                              isBlocked,
                              reason,
                              blockedAt,
                              blockedBy,
                           } = stock;
                           return {
                              id: id,
                              isOld: isOld,
                              isBox: isBox,
                              isBill: isBill,
                              isKit: isKit,
                              itemId: itemId,
                              barcode: barcode,
                              itemName: itemName,
                              serialNo: serialNo,
                              serialNo2: serialNo2,
                              specifications: specifications,
                              warehouseId: warehouseId,
                              warehouseName: warehouseName,
                              issueLineDetailId: issueLineDetailId,
                              lineItemId: lineItemId,
                              quantity2: quantity2,
                              quantity3: quantity3,
                              quantity1: quantity1,
                              pcs: quantity1,
                              isBlocked: isBlocked,
                              reason: reason,
                              blockedAt: blockedAt,
                              blockedBy: blockedBy,
                              processStatus: processStatus,
                           };
                        }),
                     takaDetails: item.purchaseLineDetail.map((x) => {
                        return { ...x, quantity3: x.quantity3, mts: x.mts || x.quantity3, usedMeter: x.RQuantity3 };
                     }),
                  };
               }) || [],
         });

         const dbOrig = daybookData?.find((d) => d.id === salesInvoice.daybookId);
         const sepOrig = dbOrig?.separator || '';
         setOriginalPrefix(
            sepOrig
               ? (salesInvoice.prefix || '').replace(new RegExp(sepOrig.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', ''), '')
               : (salesInvoice.prefix || '')
         );
         setOriginalPostFix(
            sepOrig
               ? (salesInvoice.postFix || '').replace(new RegExp('^' + sepOrig.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ''), '')
               : (salesInvoice.postFix || '')
         );

         const initialBillTerms = billTermData?.map((term) => {
            const billTerm = salesInvoice?.purchasebillterms?.find((billTerm) => billTerm.billTermId === term.id);
            if (billTerm) {
               return {
                  id: billTerm?.id,
                  billTermId: term.id,
                  percentage: billTerm?.percentage || 0,
                  amount: billTerm?.amount || 0,
               };
            } else {
               return {
                  billTermId: term.id,
                  percentage: 0,
                  amount: 0,
               };
            }
         });
         setBillTerms(initialBillTerms || []);
      }
   }, [id, salesInvoice, billTermData.length, user?.id, setFiledDisabled]);

   const handleInputChange = useCallback((header, e, idx) => {
      const { name, value } = e.target;

      setRow((prev) => ({
         ...prev,
         [header]: {
            ...prev[header],
            [name]: value,
         },
      }));

      if (name === 'dueDays') {
         setRow((prev) => {
            const transactionDate = prev[header]?.transactionAt ? moment(prev[header].transactionAt).clone() : moment(); // fallback if missing

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  dueAt: transactionDate.add(Number(value), 'days').format('YYYY-MM-DD'),
               },
            };
         });
      }

      if (name === 'dueAt') {
         setRow((prev) => {
            const transactionDate = prev[header]?.transactionAt; // "YYYY-MM-DD"

            const dueDate = moment(value, 'YYYY-MM-DD'); // user's selected due date
            const transDate = moment(transactionDate, 'YYYY-MM-DD');

            const diffDays = dueDate.diff(transDate, 'days'); // <-- main logic

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  dueDays: diffDays, // store difference in days
               },
            };
         });
      }

      if (name === 'transactionAt') {
         setRow((prev) => {
            const dueDays = Number(prev[header]?.dueDays || 0);

            // new transaction date user selected
            const transactionDate = moment(value, 'YYYY-MM-DD').clone();

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  transactionAt: value,
                  dueAt: transactionDate.add(dueDays, 'days').format('YYYY-MM-DD'),
               },
            };
         });
      }

      if (name === 'tdsAmount') {
         setRow((prev) => {
            const TDSApplyOn = daybook?.TDSApplyOn;
            const netAmount = Number(finalNetAmount || salesInvoice?.netAmount || 0);
            const taxableAmount = Number(totals?.taxableAmount || salesInvoice?.taxableAmount || 0);
            const baseAmount = TDSApplyOn === 0 ? netAmount : taxableAmount;

            const tdsRate = (Number(value) / baseAmount) * 100;
            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  tdsRate: tdsRate,
               },
            };
         });
      }

      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}.${name}`;
         delete obj[fullName];
         return obj;
      });
   }, []);

   const saveData = _.debounce(
      async () => {
         const isValid = await validateForm();

         if (isValid) {

            const prefixChanged = row.header.prefix !== originalPrefix;
            const postFixChanged = row.header.postFix !== originalPostFix;

            if (prefixChanged || postFixChanged) {
               const result = await Swal.fire({
                  title: 'Prefix / Suffix Changed',
                  text: 'Do you want to update this change in the Daybook as well?',
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, Update Daybook',
                  cancelButtonText: 'No, Only This Bill',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#6c757d',
                  focusCancel: true,
                  customClass: {
                     cancelButton: 'swal-focused-btn',
                  },
                  didOpen: () => {
                     const style = document.createElement('style');
                     style.id = 'swal-focus-style';
                     style.innerHTML = `
         .swal-focused-btn {
            outline: 3px solid #fff !important;
            outline-offset: 2px !important;
            box-shadow: 0 0 0 4px rgba(108, 117, 125, 0.7) !important;
            transform: scale(1.03) !important;
         }
      `;
                     document.head.appendChild(style);
                  },
                  didClose: () => {
                     const style = document.getElementById('swal-focus-style');
                     if (style) style.remove();
                  },
               });

               if (result.isConfirmed) {
                  const selectedDaybookToUpdate = daybookData?.find(
                     (db) => db.id === Number(row.header.daybookId)
                  );
                  if (selectedDaybookToUpdate) {
                     await dispatch(updateDaybook({
                        // ...selectedDaybookToUpdate,
                        id: selectedDaybookToUpdate.id,
                        name: selectedDaybookToUpdate.name,
                        type: Number(selectedDaybookToUpdate.type),
                        subType: Number(selectedDaybookToUpdate.subType) || 0,
                        accountId: Number(selectedDaybookToUpdate.accountId),
                        prefix: row.header.prefix,
                        suffix: row.header.postFix,
                     }));
                     setOriginalPrefix(row.header.prefix);
                     setOriginalPostFix(row.header.postFix);
                  }
               }
            }

            setIsLoading(true);
            const currentDaybookForSep = daybookData?.find((db) => db.id === Number(row.header.daybookId));
            const sep = currentDaybookForSep?.separator || '';
            const prefixToSave = (sep && row.header.prefix) ? `${row.header.prefix}${sep}` : (row.header.prefix || '');
            const suffixToSave = (sep && row.header.postFix) ? `${sep}${row.header.postFix}` : (row.header.postFix || '');
            const payload = {
               header: {
                  ...row.header,
                  ...(id && { id: id }),
                  docno: row.header?.docno?.toString()?.trim(),
                  prefix: prefixToSave,
                  postFix: suffixToSave,
                  basicAmount: formatAmount(Number(totals.netAmount)),
                  voucherId: voucher,
                  netAmount: formatAmount(Math.round(Number(finalNetAmount))),
                  companyId: Number(user?.loginhistory?.companyId),
                  accountId: Number(row.header.accountId),
                  daybookId: Number(row.header.daybookId),
                  additionAmount: row.header.additionAmount ? Number(row.header.additionAmount) : 0,
                  deductionAmount: row.header.deductionAmount ? Number(row.header.deductionAmount) : 0,
                  dueDays: row.header.dueDays ? Number(row.header.dueDays) : 0,
                  partyNo: row.header.partyNo,
                  partyDate: moment(row.header.partyDate).format('YYYY-MM-DD'),
                  transactionAt: moment(row.header.transactionAt).format('YYYY-MM-DD'),
                  dueAt: moment(row.header.dueAt).format('YYYY-MM-DD'),
                  gstAmount: totals.netGstAmount ? totals.netGstAmount : 0,
                  warehouseId: handleWarehouseId(row.header.warehouseId),
                  taxableAmount: totals.taxableAmount ? totals.taxableAmount : 0,
                  billtoStateId: getAccountAddress(accountData, row.header.accountId)?.billingAddress?.stateId ?? null,
                  shiptoStateId: getAccountAddress(accountData, row.header.accountId)?.shippingAddress?.stateId ?? null,
                  gstTxnType: getGstTaxType(company, account, 'purchase'),
                  gstSubTxnType: getGstSubTaxType(company, account, 'purchase'),
                  assesseType: company?.assesseType ? company?.assesseType : 0,
                  distance: company?.distanceKM ? company?.distanceKM : 0,
                  brokerId: row.header.brokerId || null,
                  notes: row.header.notes || null,
                  representativeId: row.header.representativeId || null,
                  incomeId: row.header.incomeId || null,
                  tdsRate: Number(row.header.tdsRate) || null,
                  tdsAmount: Number(row.header.tdsAmount) || null,
               },
               lineItem: row?.lineItem?.map((item) => {
                  const selectedItem = itemData?.find((i) => i.id.toString() === item.itemId?.toString());
                  return {
                     ...(item.id && { id: item.id }),
                     typeOfSupply: item.typeOfSupply ? item.typeOfSupply : 1,
                     itemId: item.itemId ? Number(item.itemId) : 0,
                     lineNumber: item.lineNumber ? Number(item.lineNumber) : 1,
                     itemRate: item.itemRate ? Number(item.itemRate) : 0,
                     amount: item.amount ? Number(item.amount) : 0,
                     netAmount: item.netAmount ? formatAmount(Number(item.netAmount)) : 0,
                     ratePer: item.unit && item.unit > 0 ? item.unit : selectedItem?.rateperpurchaseid,
                     uomNoForRate:
                        item.unit > 0 && item.unit === selectedItem.uqcid1
                           ? 1
                           : item.unit > 0 && item.unit === selectedItem.uqcid2
                              ? 2
                              : item.unit > 0 && item.unit === selectedItem.uqcid3
                                 ? 3
                                 : 1,
                     qUnitId1: selectedItem?.uqcid1,
                     qUnitId2: selectedItem?.uqcid2,
                     qUnitId3: selectedItem?.uqcid3,
                     qty1: item.qty1 ? Number(item.qty1) : 0,
                     qty2: item.qty2 ? Number(item.qty2) : 0,
                     qty3: item.qty3 ? Number(item.qty3) : 0,
                     addLess1Percent: item.addLess1Percent ? Number(item.addLess1Percent) : 0,
                     addLess1Amount: item.addLess1Amount ? item.addLess1Amount : 0,
                     addLess2Percent: item.addLess2Percent ? Number(item.addLess2Percent) : 0,
                     addLess2Amount: item.addLess2Amount ? item.addLess2Amount : 0,
                     addLess3Percent: item.addLess3Percent ? Number(item.addLess3Percent) : 0,
                     addLess3Amount: item.addLess3Amount ? item.addLess3Amount : 0,
                     taxableAmount: item.taxableAmount ? item.taxableAmount : 0,
                     netGst: item.netGst ? item.netGst : 0,
                     gstPercent: item.gst ? item.gst : 0,
                     cgst: isSameState ? totals.netGstAmount / 2 : 0,
                     sgst: isSameState ? totals.netGstAmount / 2 : 0,
                     igst: isSameState ? 0 : totals.netGstAmount,
                     issueLineId: item.issueLineId,
                     hsnId: selectedItem?.hsnid,
                     sacId: selectedItem?.sacid,
                     poliId: item?.poliId,
                     pcliId: item?.pcliId,
                     processStatus: undefined,
                     stock:
                        item.stock?.length > 0 && businessTypes?.businessType?.toUpperCase() === 'MOBILE'
                           ? item.stock.map((s) => {
                              return {
                                 ...s,
                                 itemId: item.itemId,
                                 warehouseId: handleWarehouseId(s.warehouseId),
                                 specifications: s.id ? s.specifications : null,
                                 returnStatus: undefined,
                                 warehouseName: undefined,
                                 purchaseStatus: undefined,
                                 processStatus: undefined,
                              };
                           })
                           : [],
                     subHSNId: item.subHSNId ?? null,
                     takaDetails:
                        item?.takaDetails?.length > 0 && businessTypes?.businessType?.toUpperCase() !== 'MOBILE'
                           ? item?.takaDetails
                              .filter((x) => x?.mts > 0 || x?.quantity3 > 0)
                              .map((a) => {
                                 return {
                                    ...(a.id && id && { id: a.id }),
                                    issueLineDetailId: a.issueLineDetailId,
                                    notes1: a.remarks ? (a.remarks ?? '') : (a.notes1 ?? ''),
                                    RQuantity1: a.RQuantity1 ? a.RQuantity1 : 0,
                                    RQuantity2: a.RQuantity2 ? a.RQuantity2 : 0,
                                    RQuantity3: a.usedMeter && a.usedMeter > 0 ? a.usedMeter : a.RQuantity3,
                                    quantity1: a.quantity1 ? a.quantity1 : 0,
                                    quantity2: a.quantity2 ? a.quantity2 : 0,
                                    quantity3: a.mts && a.mts > 0 ? a.mts : a.quantity3,
                                    pcldId: a?.pcldId ? a?.pcldId : null,
                                 };
                              })
                           : [],
                     warehouseId: handleWarehouseId(item.warehouseId),
                     isDeleted: item.isDeleted ? item.isDeleted : false,
                     notes: item.notes ? item.notes : null,
                     remarks: item.remarks ? item.remarks : null,
                     gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  };
               }),
               purchaseBillTerms: billTerms?.map((term) => ({
                  ...(term.id && { id: term.id }),
                  billTermId: Number(term.billTermId),
                  percentage: Number(term.percentage),
                  amount: Number(term.amount),
               })),
               payments: paymentData.map((payment) => {
                  let data = {};
                  if (payment.id && payment.id > 0) data.id = payment.id;
                  if (payment.outAdjustmentId && payment.outAdjustmentId > 0)
                     data.outAdjustmentId = payment.outAdjustmentId;
                  data.daybookId = Number(payment.daybookId);
                  data.amount = Number(payment.amount);
                  return data;
               }),
            };
            const newPayload = { ...payload };
            newPayload.lineItem = newPayload?.lineItem?.map((item) => {
               const ldWarehouseIds = new Set(item?.stock?.map((stock) => stock?.warehouseId));
               const warehouseId = ldWarehouseIds.values().next().value;
               return {
                  ...item,
                  warehouseId: ldWarehouseIds.size > 1 ? 1 : warehouseId,
               };
            });

            const warehouseIds = new Set(newPayload?.lineItem?.map((item) => item?.warehouseId));
            const warehouseId = warehouseIds.values().next().value;
            newPayload.header.warehouseId = warehouseIds.size > 1 ? 1 : warehouseId;
            let res;
            if (id) {
               res = await dispatch(updatePurchaseInvoice(newPayload));
            } else {
               res = await dispatch(addPurchaseInvoice(newPayload));
            }

            if (res?.code === 2) {
               setIsLoading(false);
               return;
            }

            if (res?.code === 1 && invoiceImages?.length > 0) {
               const formData = new FormData();
               formData.append('id', res?.data?.id);
               invoiceImages.forEach((imgObj) => {
                  if (!imgObj.isExisting && imgObj.file) {
                     formData.append('bill', imgObj.file);
                  }
               });

               const response = await dispatch(uploadPurchaseDocument(formData));

               if (response?.code === 1) {
                  setInvoiceImages([]);
               }
            }

            if (res?.code === 1) {
               if (user?.loginhistory?.companyId) {
                  dispatch(
                     getDaybook({
                        companyId: Number(user?.loginhistory?.companyId),
                        ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getItem({
                        companyId: user?.loginhistory.companyId,
                        sortBy: 'name',
                        sortOrder: 'asc',
                        ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getAccount({
                        compId: Number(user?.loginhistory?.companyId),
                        accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                        status: true,
                        ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
               }
               if (daybook?.onlinePrinting) {
                  if (daybook?.askBeforePrint) {
                     Swal.fire({
                        title: 'Do you want to Print Document?',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        cancelButtonColor: '#d33',
                        confirmButtonColor: '#3085d6',
                     }).then(async (result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                           if (daybook?.printingSettings === 0) {
                              await dispatch(
                                 getSetupFormat({
                                    companyId: user?.loginhistory?.companyId,
                                    daybookId: row.header.daybookId,
                                    functionName: 'Purchase Invoices',
                                 }),
                              );

                              const defaultFormat = prints.find((a) => a.isDefault);
                              if (defaultFormat) {
                                 const result = await dispatch(
                                    setupFormatCustomQuery({
                                       query: defaultFormat?.PrintFormat?.query,
                                    }),
                                 );
                                 if (result && result?.data && result?.data?.length > 0) {
                                    const html = injectDataIntoHtml(defaultFormat?.PrintFormat?.html, result?.data);
                                    handleReset();
                                    handlePrintClick(
                                       {},
                                       html,
                                       defaultFormat?.PrintFormat?.css,
                                       navigate,
                                       '/admin/purchase/invoice',
                                    );
                                 }
                              }
                           } else {
                              handleReset();
                              onOpenPrintFormatModal();
                           }
                        }

                        if (result.isDismissed) {
                           dispatch(emptyPurchase());
                           setVoucher(null);
                           await dispatch(
                              getPurchaseInvoices({
                                 page: 1,
                                 limit: 10,
                                 companyId: user?.loginhistory?.companyId,
                                 sortBy: 'id',
                                 sortOrder: 'desc',
                              }),
                           );
                           localStorage.removeItem('daybook');
                           localStorage.removeItem('accountId');
                           setIsLoading(false);
                           handleReset();
                           navigate('/admin/purchase/invoice');
                           return;
                        }
                     });
                     return;
                  }
               }

               if (
                  businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
                  daybook?.allowAutoIssue &&
                  daybook?.isGrayPurchase
               ) {
                  // onOpenIssueToMillModal();

                  Swal.fire({
                     title: 'Do you want to Send to Mill?',
                     showCancelButton: true,
                     confirmButtonText: 'Yes',
                     cancelButtonText: 'No',
                     cancelButtonColor: '#d33',
                     confirmButtonColor: '#3085d6',
                  }).then(async (result) => {
                     /* Read more about isConfirmed, isDenied below */
                     if (result.isConfirmed) {
                        setIssueData(res.data);
                        onOpenIssueToMillModal();
                        setIsLoading(false);
                        navigate(`/admin/purchase/invoice/edit/${res?.data?.id}`);
                        return;
                     }

                     if (result.isDismissed) {
                        dispatch(emptyPurchase());
                        setVoucher(null);
                        await dispatch(
                           getPurchaseInvoices({
                              page: 1,
                              limit: 10,
                              companyId: user?.loginhistory?.companyId,
                              sortBy: 'id',
                              sortOrder: 'desc',
                           }),
                        );
                        localStorage.removeItem('daybook');
                        localStorage.removeItem('accountId');
                        setIsLoading(false);
                        handleReset();
                        navigate('/admin/purchase/invoice');
                        return;
                     }
                  });

                  setIsLoading(false);
                  return;
               }
            }

            if (res?.code === 1) {
               dispatch(emptyPurchase());
               setVoucher(null);
               await dispatch(
                  getPurchaseInvoices({
                     page: 1,
                     limit: 10,
                     companyId: user?.loginhistory?.companyId,
                     sortBy: 'id',
                     sortOrder: 'desc',
                  }),
               );
               localStorage.removeItem('daybook');
               localStorage.removeItem('accountId');
               setPaymentData([]);
               setIsLoading(false);
               handleReset();
               navigate('/admin/purchase/invoice');
            }
            setIsLoading(false);
         } else {
            setIsLoading(false);
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });

            setTimeout(() => {
               if (errors['header.partyNo']) {
                  partyBillNoRef.current?.focus();
               } else if (errors['header.daybookId']) {
                  daybookRef.current?.focus();
               } else if (errors['header.docno']) {
                  docNoRef.current?.focus();
               } else if (errors['header.transactionAt']) {
                  transactionAtRef.current?.focus();
               } else if (errors['header.accountId']) {
                  accountRef.current?.focus();
               } else if (errors['header.partyDate']) {
                  partyDateRef.current?.focus();
               }
            }, 100);
         }
      },
      500,
      { leading: true, trailing: true },
   );

   const handleSubmit = useCallback(async () => {
      setIsLoading(true);
      const now = Date.now();
      if (now - lastClick.current < 1000) return;
      lastClick.current = now;

      const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);
      const data = {
         daybookId: row.header.daybookId,
         docno: row.header.docno,
         fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         companyId: user?.loginhistory?.companyId,
      };
      if (id) data.id = Number(id);
      const res = await dispatch(checkDocNo(data));
      if (res && res.code === 1 && res.data?.isError) {
         Swal.fire({
            title: res?.data?.message,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
         }).then(async (result) => {
            if (result.isConfirmed) {
               const newRow = { ...row };
               newRow.header.docno = res.data?.newDocNo.toString();
               newRow.header.partyNo = company?.setting?.partynoequaltodocno
                  ? res.data?.newDocNo.toString()
                  : newRow.header.partyNo;
               setRow(newRow);
               await saveData();
            }

            if (result.isDismissed) {
               setIsLoading(false);
               return;
            }
         });
      } else if (res && res.code === 1 && !res.data?.isError) {
         await saveData();
      } else {
         setIsLoading(false);
      }
   }, [dispatch, id, row, saveData, user?.loginhistory?.companyId]);

   const handleStock = useCallback(
      (rows) => {
         let newData = rows?.map((row) => ({
            id: row.id,
            serialNo: row.serialNo,
            serialNo2: row.serialNo2,
            barcode: row.barcode,
            note1: row.note1 ?? '',
            isOld: row.isOld,
            isBox: row.isBox,
            isBill: row.isBill,
            isKit: row.isKit,
            itemId: lastItemId,
            itemName: itemData?.find((a) => a.id === lastItemId)?.name,
            warehouseId: row.warehouseId,
         }));

         const newRow = { ...row };
         newRow.lineItem = newRow?.lineItem?.map((item, idx) => {
            if (currentIndex === idx) {
               const selectedItem = itemData?.find((a) => a.id.toString() === item.itemId.toString());
               const existingStock = Array.isArray(item.stock) ? item.stock : [];
               // const stockData = [...existingStock, ...newData];
               const stockData = newData;
               const stocks = removeDuplicates(stockData, 'serialNo');
               if (stocks?.length > 0) handleQtyChange('qty1', stocks?.length, idx);

               return {
                  ...item,
                  stock: selectedItem?.itemdetailtype === 1 ? stocks : [],
                  qty1: selectedItem?.itemdetailtype === 1 ? stocks?.length : '',
               };
            }
            return item;
         });

         setRow(newRow);
         // await dispatch(getItem())
         onCloseModal();
      },
      [currentIndex, handleQtyChange, itemData, lastItemId, onCloseModal, row],
   );

   const handlePaymentOnChange = useCallback(
      (e, index) => {
         const { name, value } = e.target;
         const newPaymentData = [...paymentData];
         newPaymentData[index][name] = value;
         setPaymentData(newPaymentData);
      },
      [paymentData],
   );

   const handlePayment = useCallback(() => {
      if (daybookPaymentData?.length > 0) {
         const payment = daybookPaymentData?.map((payment) => {
            return { daybookName: payment.name, daybookId: payment.id, account: 0 };
         });
         setPaymentData(payment);
      }
   }, [daybookPaymentData?.length]);

   const handleAskToVerifyCustomer = useCallback(async () => {
      const isValid = await validateForm();
      if (isValid) {
         if (selectedDaybook?.isAskToAllow) {
            onOpenVerifyModal();
         } else {
            handleSubmit();
         }
      } else {
         toast({
            title: 'Validation Error',
            description: getFirstErrorMessage(errors),
            status: 'error',
            duration: 3000,
            isClosable: true,
         });

         // ✅ Auto-focus the first error field
         setTimeout(() => {
            if (errors['header.partyNo']) {
               partyBillNoRef.current?.focus();
            } else if (errors['header.daybookId']) {
               daybookRef.current?.focus();
            } else if (errors['header.docno']) {
               docNoRef.current?.focus();
            } else if (errors['header.transactionAt']) {
               transactionAtRef.current?.focus();
            } else if (errors['header.accountId']) {
               accountRef.current?.focus();
            } else if (errors['header.partyDate']) {
               partyDateRef.current?.focus();
            }
         }, 100);
      }
   }, [errors, handleSubmit, onOpenVerifyModal, selectedDaybook?.isAskToAllow, toast, validateForm]);

   const handleReset = useCallback(async () => {
      console.log('reset...');
      const initialRow = {
         header: {
            daybookId: lastPurchaseDaybook?.daybookId || '',
            docno: '',
            transactionAt: new Date().toISOString().split('T')[0],
            prefix: '',
            postFix: '',
            companyId: '',
            accountId: '',
            brokerId: '',
            basicAmount: 0,
            additionAmount: '',
            deductionAmount: '',
            netAmount: 0,
            dueDays: 0,
            dueAt: new Date().toISOString().split('T')[0],
            billtoStateId: null,
            shiptoStateId: null,
            warehouseId: null,
            partyNo: '',
            partyDate: new Date().toISOString().split('T')[0],
            notes: '',
            representativeId: user?.id,
         },
         lineItem: [initialLineItem],
      };
      setRow(initialRow);
      if (user && user?.loginhistory?.companyId) {
         await dispatch(
            getPaymentDaybook({
               isPayment: true,
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
      handlePayment();
      // setSelectedStocks([]);
      setBillTerms([]);
      await dispatch(emptyPurchase());
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');
   }, [dispatch, handlePayment, initialLineItem, lastPurchaseDaybook?.daybookId, shouldSendCompanyIdDaybook, user]);

   const getPurchaseInvoiceData = useCallback(() => {
      if (id) dispatch(getPurchaseInvoice(id));
   }, [dispatch, id]);

   const getData = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         await dispatch(getUsers());
         await dispatch(
            getWarehouse({ ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }) }),
         );
         dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
      }
      await dispatch(getMainAndSubHsn());
      await dispatch(getGLGroupsAllDropdown());
      setIsPageLoading(false);
   }, [dispatch, user]);

   const getIssueDate = useCallback(async () => {
      if (daybook && daybook?.issuedaybookid && businessTypes?.businessType?.toUpperCase() === 'MOBILE') {
         await dispatch(getIssuesDocument({
            companyId: user?.loginhistory?.companyId,
            ...(id && salesInvoice && { accountId: salesInvoice?.accountId })
         }));
      }
   }, [daybook, dispatch, salesInvoice, user?.loginhistory?.companyId]);

   const getOrderData = useCallback(async () => {
      if (daybook && daybook?.orderFieldRegion === 0 && businessTypes?.businessType?.toUpperCase() !== 'MOBILE') {
         await dispatch(getOrderDocument({
            ...(daybook?.orderdaybookid && { daybookId: daybook?.orderdaybookid }),
            ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
            ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
            ...(id && row?.header?.accountId && { accountId: row.header.accountId })
         }));
      }
      if (daybook && daybook?.challanFieldRegion === 0 && businessTypes?.businessType?.toUpperCase() !== 'MOBILE') {
         await dispatch(getChallanDocument({
            ...(daybook?.challandaybookid && { daybookId: daybook?.challandaybookid }),
            companyId: user?.loginhistory?.companyId,
            ...(shouldSendCompanyIdAccount && { accountCompanyId: user?.loginhistory?.companyId, }),
            ...(shouldSendCompanyIdItem && { itemCompanyId: user?.loginhistory?.companyId, }),
            ...(id && row?.header?.accountId && { accountId: row.header.accountId })
         }));
      }
   }, [daybook, dispatch, id, row?.header?.accountId, shouldSendCompanyIdAccount, shouldSendCompanyIdItem, user?.loginhistory?.companyId]);

   const setLineItem = useCallback(() => {
      if (daybook && daybook?.issuedaybookid && issuedDoc?.length > 0) {
         const lineItem = issueDocument
            .filter((x) => issuedDoc.includes(x.issue_linedetail_id))
            .map((i) => {
               const item = itemData.find((x) => x.id === i.itemId);
               return {
                  itemId: i.itemId,
                  qty1: i.qty1 ?? 0,
                  qty2: i.qty2 ?? 0,
                  qty3: i.qty3 ?? 0,
                  unit: i.unit ? i.unit : item?.rateperpurchaseid,
                  itemRate: Number(i.itemRate) > 0 ? Number(i.itemRate) : '',
                  amount: i.amount,
                  netAmount: i.netAmount,
                  gstPercent: i.gstPercent,
                  addLess1Percent: i.addLess1Percent,
                  addLess1Amount: i.addLess1Amount,
                  addLess2Percent: i.addLess2Percent,
                  addLess2Amount: i.addLess2Amount,
                  addLess3Percent: i.addLess3Percent,
                  addLess3Amount: i.addLess3Amount,
                  lineNumber: i.lineNumber,
                  issueLineId: i.issue_lineitem_id,
                  isDeleted: false,
                  stock:
                     item?.itemdetailtype === 1
                        ? [
                           {
                              serialNo: i.issued_serial_no,
                              serialNo2: i.issued_serial_no2,
                              barcode: i.barcode,
                              note1: i.note1,
                              isOld: i.isOld,
                              itemId: i.itemId,
                              itemName: i.itemName,
                              stockId: i.stockId,
                              issueLineDetailId: i.issue_linedetail_id,
                              isBox: false,
                              isBill: false,
                              isKit: false,
                           },
                        ]
                        : [],
               };
            });

         if (id) {
            setRow((prev) => ({
               ...prev,
               lineItem: [...prev?.lineItem?.filter((item) => item.itemId && item.id).map((item) => ({ ...item, isDeleted: true })), ...lineItem],
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               lineItem: lineItem,
            }));
         }
      }
      if (daybook && daybook?.orderFieldRegion === 0 && orderDoc?.length > 0) {
         const lineItem = orderDocument
            .filter((x) => orderDoc.includes(x.id))
            .map((i, index) => {
               const item = itemData.find((x) => x.id === i.itemId);
               const selectedAccount = accountData.find((x) => x.id === i.accountId);
               let hsn = null;
               if (item?.hsnData?.subHsn.length === 1) {
                  hsn = item?.hsnData?.subHsn[0];
               } else {
                  hsn = item?.hsnData?.subHsn.find(
                     (hsn) => item.itemRate >= hsn.fromRate && item.itemRate <= hsn.toRate,
                  );
               }
               const newGSt = selectedAccount?.gstRegNo ? Number(hsn?.gst) : 0;
               const mainqty = item?.primaryuqcid === item?.uqcid1 ? i.pendingQty1 : item?.primaryuqcid === item?.uqcid2 ? i.pendingQty2 : i.pendingQty3;
               const amt = Number(i.itemRate) * mainqty;
               const netGst = (amt * newGSt) / 100;
               return {
                  itemId: i.itemId,
                  qty1: i.pendingQty1 ?? 0,
                  qty2: i.pendingQty2 ?? 0,
                  qty3: i.pendingQty3 ?? 0,
                  itemRate: Number(i.itemRate) > 0 ? Number(i.itemRate) : '',
                  amount: amt,
                  taxableAmount: amt,
                  netAmount: amt,
                  gstPercent: i.gstPercent,
                  addLess1Percent: i.addLess1Percent,
                  addLess1Amount: i.addLess1Amount,
                  addLess2Percent: i.addLess2Percent,
                  addLess2Amount: i.addLess2Amount,
                  addLess3Percent: i.addLess3Percent,
                  addLess3Amount: i.addLess3Amount,
                  // unit: item?.primaryuqcid,
                  unit: i.unit ? i.unit : item?.rateperpurchaseid,
                  gst: newGSt,
                  subHSNId: hsn?.id,
                  ratio: hsn?.ratio,
                  netGst: netGst,
                  gstAmount: netGst + amt,
                  typeOfSupply: 1,
                  // lineNumber: index + 1,
                  poliId: i.id,
                  isDeleted: false,
                  stock:
                     item?.itemdetailtype === 1
                        ? [
                           {
                              serialNo: i.issued_serial_no,
                              serialNo2: i.issued_serial_no2,
                              barcode: i.barcode,
                              note1: i.note1,
                              isOld: i.isOld,
                              itemId: i.itemId,
                              itemName: i.itemName,
                              stockId: i.stockId,
                              issueLineDetailId: i.issue_linedetail_id,
                              isBox: false,
                              isBill: false,
                              isKit: false,
                           },
                        ]
                        : [],
               };
            });

         if (id) {
            setRow((prev) => ({
               ...prev,
               lineItem: [...(prev.lineItem || []).filter((item) => !item.poliId || (item.poliId && item.id)).map((item) => ({ ...item })),
               ...lineItem],
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               lineItem: lineItem,
            }));
         }
      }
      if (daybook && daybook?.challanFieldRegion === 0 && challanDoc?.length > 0) {

         const lineItem = challanDocument
            .filter((x) => challanDoc.includes(x.id))
            .map((i, index) => {
               const item = itemData.find((x) => x.id === i.itemId);
               const selectedAccount = accountData.find((x) => x.id === i.accountId);
               let hsn = null;
               if (item?.hsnData?.subHsn.length === 1) {
                  hsn = item?.hsnData?.subHsn[0];
               } else {
                  hsn = item?.hsnData?.subHsn.find(
                     (hsn) => item.itemRate >= hsn.fromRate && item.itemRate <= hsn.toRate,
                  );
               }
               const newGSt = selectedAccount?.gstRegNo ? Number(hsn?.gst) : 0;
               const mainqty = item?.primaryuqcid === item?.uqcid1 ? i.pendingQty1 : item?.primaryuqcid === item?.uqcid2 ? i.pendingQty2 : i.pendingQty3;
               const amt = Number(i.itemRate) * mainqty;
               const netGst = (amt * newGSt) / 100;

               const takaDetails = i?.purchaseLineDetail?.map((a) => {
                  return {
                     itemName: item.itemName,
                     itemId: a.itemId,
                     // pinvLineDetailId: item.type?.toLowerCase() === "purchase" ? i.id : null,
                     pinvLineDetailId: null,
                     quantity1: a.pendingQty1,
                     quantity2: a.pendingQty2,
                     quantity3: a.pendingQty3,
                     isSelected: true,
                     id: a.id,
                     issueQty3: 0,
                     purchaseQty3: a.pendingQty3,
                     pcldId: a.id,
                  };
               });
               return {
                  itemId: i.itemId,
                  qty1: takaDetails?.length > 0 ? takaDetails?.length : i?.pendingQty1 ?? 0,
                  qty2: i?.pendingQty2 ?? 0,
                  qty3: takaDetails?.length > 0 ? takaDetails?.reduce((acc, curr) => acc + curr.pendingQty3, 0) : i?.pendingQty3 ?? 0,
                  itemRate: Number(i.itemRate) > 0 ? Number(i.itemRate) : '',
                  amount: amt,
                  taxableAmount: amt,
                  netAmount: amt,
                  gstPercent: i.gstPercent,
                  addLess1Percent: i.addLess1Percent,
                  addLess1Amount: i.addLess1Amount,
                  addLess2Percent: i.addLess2Percent,
                  addLess2Amount: i.addLess2Amount,
                  addLess3Percent: i.addLess3Percent,
                  addLess3Amount: i.addLess3Amount,
                  // unit: item?.primaryuqcid,
                  unit: i.unit ? i.unit : item?.rateperpurchaseid,
                  gst: newGSt,
                  subHSNId: hsn?.id,
                  ratio: hsn?.ratio,
                  netGst: netGst,
                  gstAmount: netGst + amt,
                  typeOfSupply: 1,
                  // lineNumber: index + 1,
                  pcliId: i.id,
                  isDeleted: false,
                  takaDetails: takaDetails,
                  stock: [],
               };
            });
         if (id) {
            setRow((prev) => ({
               ...prev,
               lineItem: [...(prev.lineItem || []).filter((item) => !item.pcliId || (item.pcliId && item.id)).map((item) => ({ ...item })),
               ...lineItem],
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               lineItem: lineItem,
            }));
         }
      }
   }, [daybook, issueDocument?.length, orderDocument?.length, challanDocument?.length, issuedDoc, orderDoc, challanDoc, itemData?.length]);


   const setLineItemMillIssue = useCallback(() => {
      if (millIssueDoc.length > 0 && businessTypes?.businessType?.toUpperCase() === 'TEXTILE' && daybook?.issuedaybookid && daybook?.isMillReceive) {
         if (id) {
            const selectedTakaDetails = millIssueDocument?.filter((x) => millIssueDoc.includes(x.id))
            const newRows = { ...row };
            const editLineItem = newRows.lineItem.filter((item) => item.id)
            // 👉 marge old and new taka details
            newRows.lineItem = newRows.lineItem.map((item) => {
               const newTakaDetails = selectedTakaDetails
                  ?.filter((x) => x.id === item.issueLineId)
                  ?.flatMap((a) => {
                     return a.issueLineDetail?.map((i) => {
                        return {
                           ...i,
                           itemName: item.itemName,
                           itemId: i.itemId,
                           issueLineDetailId: i.id,
                           quantity1: i.pendingQty1,
                           quantity2: i.pendingQty2,
                           quantity3: i.pendingQty3,
                           mts: "",
                           remarks: "",
                           id: i.id
                        }
                     })
                  })
               const oldTaka = Array.isArray(item?.takaDetails) && item?.takaDetails?.length > 0 ? item?.takaDetails : []
               const allTaka = [...oldTaka, ...newTakaDetails]
               const selectedItem = itemData.find((a) => a.id === item.itemId)
               // const selectedAccount = accountData.find((x) => x.id === item.accountId);


               return {
                  ...item,
                  itemId: item.itemId,
                  unit: item.unit ? item.unit : selectedItem?.rateperpurchaseid,
                  issueLineId: item.issueLineId,
                  gst: item.gst,
                  subHSNId: item.subHSNId,
                  // gstAmount: item.gstAmount,
                  // amount: item.amount,
                  // taxableAmount: item.taxableAmount,
                  // netAmount: item.netAmount,
                  isDeleted: false,
                  stock: [],
                  takaDetails: removeDuplicateItdRecords(mergeUsedMeter(allTaka))
               }
            })
            setRow(newRows)

            // 👉 add new line item and taka detail
            const liIds = newRows.lineItem
               .filter((item) => item.issueLineId)
               .map((item) => item.issueLineId).filter(Boolean)


            const selectedTakaDetailsIds = selectedTakaDetails
               ?.filter((x) => !liIds.includes(x.id))
               .map((item, idx) => {
                  let row = idx + 1;
                  const selectedItem = itemData.find((x) => x.id === item.itemId);
                  const selectedAccount = accountData.find((x) => x.id === item.accountId);
                  item.typeOfSupply = item.typeOfSupply ? item.typeOfSupply : daybook?.typeOfSupply ? daybook?.typeOfSupply : 1
                  if (company?.gstRegNo && company?.setting?.applyGST && daybook?.applyGst) {
                     let hsn;
                     if (item?.typeOfSupply === 1) {
                        if (selectedItem?.hsnData?.subHsn.length === 1) {
                           hsn = selectedItem?.hsnData?.subHsn[0];
                        } else {
                           hsn = selectedItem?.hsnData?.subHsn.find(
                              (hsn) => item.itemRate >= hsn.fromRate && item.itemRate <= hsn.toRate,
                           );
                        }
                     }
                     if (item?.typeOfSupply === 2) {
                        if (selectedItem?.sacData?.subHsn.length === 1) {
                           hsn = selectedItem?.sacData?.subHsn[0];
                        } else {
                           hsn = selectedItem?.sacData?.subHsn.find(
                              (hsn) => item.itemRate >= hsn.fromRate && item.itemRate <= hsn.toRate,
                           );
                        }
                     }
                     const newGSt = selectedAccount?.gstRegNo ? Number(hsn?.gst) : 0;
                     const mainqty = selectedItem?.primaryuqcid === selectedItem?.uqcid1 ? item.pendingQty1 : selectedItem?.primaryuqcid === selectedItem?.uqcid2 ? item.pendingQty2 : item.pendingQty3;
                     const amt = Number(item.itemRate) * mainqty;
                     const netGst = (amt * newGSt) / 100;
                     item.amount = amt
                     item.taxableAmount = amt
                     item.netAmount = amt
                     item.gst = newGSt
                     item.netGst = netGst
                     item.gstAmount = netGst + amt
                     item.subHSNId = hsn?.id ?? null
                  }


                  const taktaDetails = item?.issueLineDetail?.map((i) => {
                     return {
                        ...i,
                        itemName: item.itemName,
                        itemId: i.itemId,
                        issueLineDetailId: i.id,
                        quantity1: i.pendingQty1,
                        quantity2: i.pendingQty2,
                        quantity3: i.pendingQty3,
                        mts: "",
                        remarks: "",
                        id: i.id
                     }
                  })
                  return {
                     itemId: item.itemId,
                     unit: item.unit ? item.unit : selectedItem?.rateperpurchaseid,
                     issueLineId: item.id,
                     lineNumber: row,
                     gst: item.gst,
                     subHSNId: item.subHSNId,
                     // gstAmount: item.gstAmount,
                     // amount: item.amount,
                     // taxableAmount: item.taxableAmount,
                     // netAmount: item.netAmount,
                     isDeleted: false,
                     stock: [],
                     takaDetails: taktaDetails
                  }
               });

            setRow((prev) => ({
               ...prev,
               lineItem: id && id > 0 ? [...prev.lineItem, ...selectedTakaDetailsIds] : selectedTakaDetailsIds,
            }));

            return;
         }

         const lineItem = millIssueDocument
            .filter((x) => millIssueDoc.includes(x.id))
            .map((item, idx) => {
               let row = idx + 1;
               const selectedItem = itemData.find((x) => x.id === item.itemId);
               const selectedAccount = accountData.find((x) => x.id === item.accountId);
               item.typeOfSupply = item.typeOfSupply ? item.typeOfSupply : daybook?.typeOfSupply ? daybook?.typeOfSupply : 1
               if (company?.gstRegNo && company?.setting?.applyGST && daybook?.applyGst) {
                  let hsn;
                  if (item?.typeOfSupply === 1) {
                     if (selectedItem?.hsnData?.subHsn.length === 1) {
                        hsn = selectedItem?.hsnData?.subHsn[0];
                     } else {
                        hsn = selectedItem?.hsnData?.subHsn.find(
                           (hsn) => item.itemRate >= hsn.fromRate && item.itemRate <= hsn.toRate,
                        );
                     }
                  }
                  if (item?.typeOfSupply === 2) {
                     if (selectedItem?.sacData?.subHsn.length === 1) {
                        hsn = selectedItem?.sacData?.subHsn[0];
                     } else {
                        hsn = selectedItem?.sacData?.subHsn.find(
                           (hsn) => item.itemRate >= hsn.fromRate && item.itemRate <= hsn.toRate,
                        );
                     }
                  }
                  const newGSt = selectedAccount?.gstRegNo ? Number(hsn?.gst) : 0;
                  const mainqty = selectedItem?.primaryuqcid === selectedItem?.uqcid1 ? item.pendingQty1 : selectedItem?.primaryuqcid === selectedItem?.uqcid2 ? item.pendingQty2 : item.pendingQty3;
                  const amt = Number(item.itemRate) * mainqty;
                  const netGst = (amt * newGSt) / 100;
                  item.amount = amt
                  item.taxableAmount = amt
                  item.netAmount = amt
                  item.gst = newGSt
                  item.netGst = netGst
                  item.gstAmount = netGst + amt
                  item.subHSNId = hsn?.id ?? null
               }


               const taktaDetails = item?.issueLineDetail?.map((i) => {
                  return {
                     ...i,
                     itemName: item.itemName,
                     itemId: i.itemId,
                     issueLineDetailId: i.id,
                     quantity1: i.pendingQty1,
                     quantity2: i.pendingQty2,
                     quantity3: i.pendingQty3,
                     mts: "",
                     remarks: "",
                     id: i.id
                  }
               })
               return {
                  itemId: item.itemId,
                  unit: item.unit ? item.unit : selectedItem?.rateperpurchaseid,
                  issueLineId: item.id,
                  lineNumber: row,
                  gst: item.gst,
                  subHSNId: item.subHSNId,
                  // gstAmount: item.gstAmount,
                  // amount: item.amount,
                  // taxableAmount: item.taxableAmount,
                  // netAmount: item.netAmount,
                  isDeleted: false,
                  stock: [],
                  takaDetails: taktaDetails
               }
            });

         setRow((prev) => ({
            ...prev,
            lineItem: id && id > 0 ? [...prev.lineItem, ...lineItem] : lineItem,
         }));
      }
   }, [daybook, businessTypes?.businessType, daybook?.isMillIssue, daybook?.issuedaybookid, millIssueDocument, millIssueDoc, itemData?.length])

   const handleTakaDetails = useCallback(
      (takaDetails) => {

         takaDetails = takaDetails
            ?.filter((q) => q.qty > 0)
            ?.map((t) => ({
               ...(t.id && id && { id: t.id }),
               quantity1: 0,
               quantity2: 0,
               quantity3: t.qty ? Number(t.qty) : 0,
               notes1: '',
               issueLineDetailId: null,
               RQuantity1: 0,
               RQuantity2: 0,
               RQuantity3: 0,
            }));

         const totalTaka = takaDetails?.reduce((acc, item) => acc + Number(item?.quantity3 || 0), 0);
         setRow((prev) => ({
            ...prev,
            lineItem: prev?.lineItem?.map((item, idx) => {
               if (currentIndex === idx) {
                  const selectedItem = itemData.find((i) => i.id === item.itemId);
                  const unit = item.unit ?? selectedItem.rateperpurchaseid;
                  const qty1 = takaDetails?.length > 0 ? takaDetails?.length : 0;
                  const qty2 = selectedItem?.defaultcut > 0 ? Number(selectedItem?.defaultcut) : 0;
                  const qty3 = totalTaka;
                  handleQtyChange('qty3', qty3, idx);
                  return {
                     ...item,
                     qty1: qty1,
                     qty2: qty2,
                     qty3: qty3,
                     unit: unit,
                     takaDetails: [...takaDetails, { itemId: item.itemId }],
                  };
               }
               return item;
            }),
         }));
      },
      [currentIndex, handleQtyChange, itemData],
   );

   const handleSaveTakaDetail = useCallback(
      (data) => {
         let newRows = { ...row }
         const selectedTakaDetail = data.filter((a) => a.mts > 0);
         const totalTakaDetails = selectedTakaDetail.reduce((acc, item) => acc + Number(item?.mts || 0), 0);
         const totalUsedMeter = selectedTakaDetail.reduce((acc, item) => acc + Number(item?.usedMeter || 0), 0);
         newRows.lineItem[currentIndex].qty1 = selectedTakaDetail?.length;
         newRows.lineItem[currentIndex].qty2 = 0;
         newRows.lineItem[currentIndex].qty3 = totalUsedMeter;
         newRows.lineItem[currentIndex].takaDetails = data;
         setRow(newRows);
      },
      [currentIndex],
   );

   const handleSaveTakaDetailChallan = useCallback(
      (data) => {
         const newRows = { ...row }
         const selectedTakaDetail = data.filter((a) => a.isSelected);
         const totalTakaDetails = selectedTakaDetail.reduce(
            (acc, item) => acc + Number(item?.quantity3 || 0),
            0,
         );
         newRows.lineItem[currentIndex].qty1 = selectedTakaDetail.length;
         newRows.lineItem[currentIndex].qty3 = totalTakaDetails;
         newRows.lineItem[currentIndex].takaDetails = selectedTakaDetail;
         setRow(newRows)
      },
      [currentIndex],
   );

   useEffect(() => {
      async function fetchData() {
         await dispatch(getMillPendingIssue({
            companyId: user?.loginhistory?.companyId,
            ...(row?.header?.accountId && { accountId: row?.header?.accountId }),
            ...(daybook?.issuedaybookid && { daybookId: daybook?.issuedaybookid }),
         }))
      }
      if (user?.loginhistory?.companyId) {
         if (
            businessTypes?.businessType?.toUpperCase() === 'TEXTILE' &&
            daybook?.isMillReceive && daybook?.issuedaybookid
         ) {
            fetchData()
         }
      }
   }, [businessTypes?.businessType, daybook?.isMillReceive, daybook?.issuedaybookid, dispatch, row?.header?.accountId, user?.loginhistory?.companyId])

   // get default list
   useEffect(() => {
      if (user && !user?.packageData?.[0]?.purchase_invoice) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      getData();
   }, [getData]);

   useEffect(() => {
      getIssueDate();
   }, [getIssueDate]);

   useEffect(() => {
      setLineItem();
      return () => { };
   }, [setLineItem]);

   useEffect(() => {
      setLineItemMillIssue();
      return () => { };
   }, [setLineItemMillIssue]);

   useEffect(() => {
      if (row.header.daybookId || lastPurchaseDaybook?.daybookId) {
         const daybookId = row.header.daybookId ? row.header.daybookId : lastPurchaseDaybook?.daybookId;
         dispatch(
            getBillTerm({
               daybookId: daybookId,
               ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, lastPurchaseDaybook?.daybookId, row.header.daybookId]);

   // edit data by id
   useEffect(() => {
      getPurchaseInvoiceData();
   }, [getPurchaseInvoiceData]);

   // set new create account id
   useEffect(() => {
      if (accountId) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               accountId: accountId,
            },
         }));
      }
   }, [accountId]);

   // set create account data
   useEffect(() => {
      if (id && salesInvoice) {
         handleEditValues();
      }
   }, [handleEditValues, id, salesInvoice]);

   // set last sale daybook
   useEffect(() => {
      if (lastPurchaseDaybook && lastPurchaseDaybook.docno) {
         const currentDocNo = String(lastPurchaseDaybook.docno ?? 0);
         const nextDocNo =
            salesInvoice?.daybookId === lastPurchaseDaybook?.daybookId
               ? salesInvoice?.docno
               : ((parseInt(currentDocNo) + 1).toString() ?? '1');

         if (!id) {
            // ✅ Add mode — prefix/suffix + docno sab update
            const selectedDaybookForPrefix = daybookData?.find(
               (db) => db.id === Number(lastPurchaseDaybook.daybookId)
            );
            if (selectedDaybookForPrefix) {
               const sep = selectedDaybookForPrefix.separator || '';
               const escaped = sep ? sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '';
               const cleanPrefix = sep
                  ? (selectedDaybookForPrefix.prefix || '').replace(new RegExp(escaped + '$', ''), '')
                  : (selectedDaybookForPrefix.prefix || '');
               const cleanSuffix = sep
                  ? (selectedDaybookForPrefix.suffix || '').replace(new RegExp('^' + escaped, ''), '')
                  : (selectedDaybookForPrefix.suffix || '');
               setOriginalPrefix(cleanPrefix);
               setOriginalPostFix(cleanSuffix);
               setRow((prev) => ({
                  ...prev,
                  header: {
                     ...prev.header,
                     daybookId: lastPurchaseDaybook.daybookId,
                     docno: nextDocNo,
                     partyNo: company?.setting?.partynoequaltodocno ? nextDocNo : '',
                     prefix: cleanPrefix,
                     postFix: cleanSuffix,
                  },
                  lineItem: prev?.lineItem?.map((item) => ({
                     ...item,
                     typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
                  })),
               }));
            } else {
               setRow((prev) => ({
                  ...prev,
                  header: {
                     ...prev.header,
                     daybookId: lastPurchaseDaybook.daybookId,
                     docno: nextDocNo,
                     partyNo: company?.setting?.partynoequaltodocno ? nextDocNo : '',
                  },
                  lineItem: prev?.lineItem?.map((item) => ({
                     ...item,
                     typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
                  })),
               }));
            }
         } else {
            // ✅ Edit mode — sirf docno update, prefix/suffix kabhi nahi
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  docno: nextDocNo,
               },
            }));
         }
      } else if (!id) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               docno: '1',
               partyNo: company?.setting?.partynoequaltodocno ? '1' : '',
            },
            lineItem: prev?.lineItem?.map((item) => ({
               ...item,
               typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
            })),
         }));
      }
   }, [company?.setting?.partynoequaltodocno, daybook?.typeOfSupply, id, lastPurchaseDaybook, daybookData?.length]);

   useEffect(() => {
      if (salesInvoice && salesInvoice?.daybookId && !daybookId) {
         setDaybookId(salesInvoice?.daybookId);
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: Number(salesInvoice?.daybookId),
            },
         }));
      } else if (row) {
         setDaybookId(daybookId);
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: Number(daybookId),
            },
         }));
      }
   }, [daybookId, setDaybookId, salesInvoice?.daybookId]);

   useEffect(() => {
      if (billTermData && billTermData?.length > 0 && !id) {
         const initialBillTerms = billTermData?.map((term) => {
            return {
               billTermId: term.id,
               percentage: term.percentValue || 0,
               amount: 0,
            };
         });
         setBillTerms(initialBillTerms);
      }
   }, [billTermData, id]);

   useEffect(() => {
      if (row.header.accountId) {
         const state = account?.accountaddress?.find((a) => a.name === 'billing')?.stateId;
         const companyState = company?.stateid;
         setIsSameState(state?.toString() === companyState?.toString());
      }
   }, [account?.accountaddress, company?.stateid, row.header.accountId]);

   useEffect(() => {
      const flattenedStocks = row?.lineItem
         ?.filter((x) => x.isDeleted === false)
         ?.flatMap((item) =>
            item?.stock
               ?.map((s) => {
                  const changeItem = itemData.find((i) => i.id === item.itemId);
                  if (!item.itemId) return null;
                  if (item.itemId !== s.itemId) return null;
                  return { ...s, itemId: item.itemId, itemName: changeItem?.name };
               })
               .filter(Boolean),
         );
      setRow((prevRow) => ({
         ...prevRow,
         lineItem: prevRow?.lineItem?.map((item, index) => {
            const changeItem = itemData.find((i) => i.id === item?.itemId);
            return {
               ...item,
               stock: item?.stock
                  ?.map((s) =>
                     item.itemId === s?.itemId ? { ...s, itemId: item?.itemId, itemName: changeItem?.name } : null,
                  )
                  .filter(Boolean),
            };
         }),
      }));

      setSelectedStocks(flattenedStocks?.length > 0 ? flattenedStocks : null);
   }, [JSON.stringify(row.lineItem)]);

   useEffect(() => {
      setStockList(stocks);
   }, [stocks]);

   useEffect(() => {
      handlePayment();
   }, [handlePayment]);

   useEffect(() => {
      if (row.header.daybookId && user && user?.loginhistory?.companyId) {
         const daybookById = {
            id: Number(row.header.daybookId),
            compId: String(user?.loginhistory?.companyId),
         };
         dispatch(getDaybookById(daybookById));
      }
   }, [dispatch, row.header.daybookId, user]);

   useEffect(() => {
      if (!id || vouchers?.length === 0 || daybookPaymentData?.length === 0) return;

      setPaymentData((prevPaymentData) =>
         prevPaymentData.map((payment) => {
            const matchingVoucher = vouchers.find((voucher) => voucher.daybookId === payment.daybookId);

            return {
               ...payment,
               id: matchingVoucher?.id ?? null,
               amount: matchingVoucher?.amount ?? 0,
               outAdjustmentId: matchingVoucher?.outAdjustmentId ?? null,
            };
         }),
      );
   }, [id, vouchers, daybookPaymentData]);

   useEffect(() => {
      prepareRowRefs(row?.lineItem?.length);
   }, [row?.lineItem?.length]);

   useEffect(() => {
      prepareBillTermRowRefs(billTermData?.length);
   }, [billTermData?.length]);

   useEffect(() => {
      preparePaymentRowRefs(paymentData?.length);
   }, [paymentData?.length]);

   // useEffect(() => {
   //    if (!id) {
   //       if (row.header.daybookId) {
   //          if (daybookRef.current) {
   //             daybookRef.current.focus();
   //          }
   //       }
   //    }
   // }, [id, row.header.daybookId, isPageLoading]);

   useEffect(() => {
      if (!id && !isPageLoading) {
         const timer = setTimeout(() => {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }, 100);
         return () => clearTimeout(timer);
      }
   }, [id, isPageLoading]);

   useEffect(() => {
      if (!id) {
         setRow((prev) => ({
            ...prev,
            header: { ...prev.header, representativeId: user?.id },
         }));
      }
   }, [id, user?.id]);

   const filteredDaybooks = daybookData.filter((item) => item.type === 11);
   const daybookbalance = filteredDaybooks.find((item) => item.id === row?.header?.daybookId)?.bal ?? null;

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== docNoRef.current) {
               docNoRef.current?.focus();
            } else {
               window.history.back();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const selectdaybookdata = daybookData.find((daybook) => daybook.id === row.header.daybookId);
   const herderview =
      selectdaybookdata?.warehouseInId === 1
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 1
               ? true
               : false
            : false;
   const lineitemview =
      selectdaybookdata?.warehouseInId === 2
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 2
               ? true
               : false
            : false;
   const lineDetailview =
      selectdaybookdata?.warehouseInId === 3
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 3
               ? true
               : false
            : false;

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (herderview === true) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  warehouseId: selectdaybookdata?.wareHouseId
                     ? selectdaybookdata?.wareHouseId
                     : companyData?.setting?.warehouseId
                        ? companyData?.setting?.warehouseId
                        : 1,
               },
            }));
         }
      }
   }, [row.header.daybookId]);

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (lineitemview === true) {
            setRow((prev) => ({
               ...prev,
               lineItem: Array.isArray(prev.lineItem)
                  ? prev.lineItem.map((item) => ({
                     ...item,
                     warehouseId:
                        item.warehouseId === null
                           ? selectdaybookdata?.wareHouseId
                              ? selectdaybookdata?.wareHouseId
                              : companyData?.setting?.warehouseId
                                 ? companyData?.setting?.warehouseId
                                 : 1
                           : item.warehouseId,
                  }))
                  : [],
            }));
         }
      }
   }, [row.header.daybookId, JSON.stringify(row.lineItem)]);

   useEffect(() => {
      getOrderData();
   }, [getOrderData]);

   useEffect(() => {
      setLineItem();
      return () => { };
   }, [setLineItem]);

   return (
      <>
         <Card
            flexDirection="column"
            w="100%"
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            // mt="-145px"
            mt="40px"
            position="relative"
            minH={'90vh'}
            maxH={'90vh'}
            overflowY={'scroll'}>
            <CardHeader>
               <Heading size="md">
                  <Flex gap={3} justifyContent="space-between" alignItems="center">
                     <Box>
                        <Flex alignItems="center" gap={2}>
                           <img
                              src={back}
                              alt="Go Back"
                              width="15px"
                              onClick={() => {
                                 handleReset();
                                 window.history.back();
                              }} // Navigate to the previous page
                              style={{ cursor: 'pointer' }} // Ensure it's clickable
                           ></img>
                           {id ? 'Update' : 'Add'} Purchase Invoice
                           {typeof daybookbalance === 'number' && daybookbalance !== 0 && (
                              <Text
                                 as="span"
                                 fontSize="sm"
                                 fontWeight="normal"
                                 ml={2}
                                 color={daybookbalance < 0 ? 'green.500' : 'red.500'}>
                                 (Balance:
                                 <>
                                    ₹{(Math.abs(daybookbalance)?.toFixed(2) || '0.00').split('.')[0]}.
                                    <Text as="span" fontSize="11px" verticalAlign="baseline">
                                       {(Math.abs(daybookbalance)?.toFixed(2) || '0.00').split('.')[1]}
                                    </Text>
                                 </>
                                 )
                              </Text>
                           )}
                        </Flex>
                     </Box>
                     {id && salesInvoice ? (
                        <Box>
                           <Flex gap={2} alignItems="center">
                              <Heading as="h3" size="lg">
                                 {salesInvoice?.pendingamt ? `₹${salesInvoice?.pendingamt}` : ''}
                              </Heading>
                              <Badge
                                 border="1px solid"
                                 bg="transparent"
                                 borderColor={pendingPayment?.borderColor}
                                 color={pendingPayment?.badgeColor}
                                 borderRadius="md"
                                 w="100%"
                                 textAlign="center"
                                 textTransform="capitalize">
                                 {salesInvoice?.pendingstatus?.replace(/\s*\[.*?\]/, '')?.trim()}
                              </Badge>
                              <Icon
                                 as={FaCircleInfo}
                                 boxSize={4}
                                 // ml={3}
                                 color="green.600"
                                 onClick={handleAdjustedDocs}
                                 cursor="pointer"
                              />
                           </Flex>
                        </Box>
                     ) : null}
                  </Flex>
               </Heading>
            </CardHeader>
            <CardBody>
               <Box position="relative">
                  {isPageLoading ? (
                     <Flex w="full" justifyContent="center" alignItems="center">
                        <Image src={loaderAnimation} width={150} height={150} objectFit="cover" />
                     </Flex>
                  ) : (
                     <>
                        <form>
                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>

                              {/* 👉 Daybook Id field  */}
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'daybookId',
                                    'Daybook',
                                    daybookData.filter((item) => item.type === 11),
                                    {
                                       errorName: 'header.daybookId',
                                       value: row.header.daybookId,
                                       onChange: (value) => handleDaybook('daybookId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: daybookRef,
                                       nextRef: docNoRef,
                                       disabled: businessTypes?.businessType?.toUpperCase() === 'TEXTILE' ? filedDisabled : false,
                                       showCustomNoOptions: true,
                                       openfrom: 'salesdaybook',
                                       type: 11,
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Daybook',
                                 )}
                              </GridItem>

                              {/* 👉 Document Number field  */}
                              <GridItem colSpan={1}>
                                 <Flex gap={2}>
                                    <Box flex={1}>
                                       <InputField
                                          type="text"
                                          name="prefix"
                                          label="Prefix"
                                          value={(() => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const clean = row.header.prefix || '';
                                             if (!clean) return '';
                                             return sep ? `${clean}${sep}` : clean;
                                          })()}
                                          onChange={(e) => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const rawValue = e.target.value;
                                             let cleanValue = sep
                                                ? rawValue.replace(new RegExp(sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '')
                                                : rawValue;
                                             cleanValue = cleanValue.replace(/[^A-Za-z0-9]/g, '');
                                             const sanitizedEvent = {
                                                ...e,
                                                target: { ...e.target, value: cleanValue, name: e.target.name },
                                             };
                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                       // onKeyDown={(e) => handleKeyDown(e, docNoRef, daybookRef)}
                                       />
                                    </Box>
                                    <Box flex={1}>
                                       <InputField
                                          ref={docNoRef}
                                          type="text"
                                          name="docno"
                                          label="Doc No"
                                          value={row.header.docno}
                                          onChange={(e) => {
                                             const sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
                                             const sanitizedEvent = {
                                                ...e,
                                                target: {
                                                   ...e.target,
                                                   value: sanitizedValue,
                                                   name: e.target.name,
                                                },
                                             };

                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                          onKeyDown={async (e) => {
                                             if (e.key === 'PageUp') {
                                                e.preventDefault();
                                                if (!id) {
                                                   if (lastPurchaseDaybook?.id)
                                                      navigate(`/admin/purchase/invoice/edit/${lastPurchaseDaybook?.id}`);
                                                } else {
                                                   const res = await dispatch(
                                                      getPrevAndNext({
                                                         id: id,
                                                         daybookId: row.header.daybookId,
                                                         companyId: user?.loginhistory?.companyId,
                                                      }),
                                                   );
                                                   if (res.prev) {
                                                      navigate(`/admin/purchase/invoice/edit/${res.prev}`);
                                                   } else {
                                                      handleReset();
                                                      navigate(`/admin/purchase/invoice/add`);
                                                   }
                                                }
                                                return;
                                             }
                                             if (e.key === 'PageDown') {
                                                e.preventDefault();
                                                if (!id) {
                                                   if (lastPurchaseDaybook?.id)
                                                      navigate(`/admin/purchase/invoice/edit/${lastPurchaseDaybook?.id}`);
                                                } else {
                                                   const res = await dispatch(
                                                      getPrevAndNext({
                                                         id: id,
                                                         daybookId: row.header.daybookId,
                                                         companyId: user?.loginhistory?.companyId,
                                                      }),
                                                   );
                                                   if (res.next) {
                                                      navigate(`/admin/purchase/invoice/edit/${res.next}`);
                                                   } else {
                                                      handleReset();
                                                      navigate(`/admin/purchase/invoice/add`);
                                                   }
                                                }
                                                return;
                                             }
                                             handleKeyDown(e, transactionAtRef, daybookRef);
                                          }}
                                          autoFocus={id > 0 ? true : false}
                                       />
                                    </Box>
                                    <Box flex={1}>
                                       <InputField
                                          type="text"
                                          name="postFix"
                                          label="Suffix"
                                          value={(() => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const clean = row.header.postFix || '';
                                             if (!clean) return '';
                                             return sep ? `${sep}${clean}` : clean;
                                          })()}
                                          onChange={(e) => {
                                             const db = daybookData?.find((d) => d.id === Number(row.header.daybookId));
                                             const sep = db?.separator || '';
                                             const rawValue = e.target.value;
                                             let cleanValue = sep
                                                ? rawValue.replace(new RegExp(sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), '')
                                                : rawValue;
                                             cleanValue = cleanValue.replace(/[^A-Za-z0-9]/g, '');
                                             const sanitizedEvent = {
                                                ...e,
                                                target: { ...e.target, value: cleanValue, name: e.target.name },
                                             };
                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                       // onKeyDown={(e) => handleKeyDown(e, transactionAtRef, docNoRef)}
                                       />
                                    </Box>
                                 </Flex>
                              </GridItem>

                              {/* 👉 Acccount Details  */}
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 {account &&
                                    (account.mobile ||
                                       account.email ||
                                       account.panNo ||
                                       account.addressJson?.length > 0 ||
                                       account.gstRegNo ||
                                       account.brokername ||
                                       account.amt) ? (
                                    <Box
                                       border="1.5px solid"
                                       borderColor="gray.200"
                                       borderRadius="15px"
                                       padding="20px"
                                       marginLeft="40px"
                                       width="80%">
                                       {/* First Row: Mobile, Email, PAN */}
                                       <Flex gap={6} mb={4} flexWrap="wrap">
                                          {account.mobile && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={phone} alt="Phone Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.mobile}</Text>
                                             </Flex>
                                          )}

                                          {account.email && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={Email} alt="Email Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.email}</Text>
                                             </Flex>
                                          )}

                                          {account.panNo && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={panno} alt="PAN Icon" boxSize="22px" mr={2} />
                                                <Text fontSize="sm">{account.panNo}</Text>
                                             </Flex>
                                          )}
                                       </Flex>

                                       {/* Second Row: Address */}
                                       {account.addressJson?.length > 0 && (
                                          <Flex alignItems="start" mb={4}>
                                             <Image src={map} alt="Address Icon" boxSize="20px" mr={2} mt={1} />
                                             <Box>
                                                {account.addressJson.map((address, index) => (
                                                   <Text key={index} fontSize="sm">
                                                      {address.address1}
                                                   </Text>
                                                ))}
                                             </Box>
                                          </Flex>
                                       )}

                                       {/* Third Row: GST, Broker, Balance */}
                                       <Flex gap={6} flexWrap="wrap">
                                          {account.gstRegNo && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={gstno} alt="GST Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.gstRegNo}</Text>
                                             </Flex>
                                          )}

                                          {account.brokername && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={Brokername} alt="Broker Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.brokername}</Text>
                                             </Flex>
                                          )}

                                          {account.amt ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={Balance}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Balance Icon"
                                                />
                                                {account.amt}
                                             </GridItem>
                                          ) : null}
                                       </Flex>
                                    </Box>
                                 ) : null}
                              </GridItem>

                              {/* 👉 Transaction Date field  */}
                              <GridItem w="100%">
                                 <InputField
                                    ref={transactionAtRef}
                                    type="date"
                                    name="transactionAt"
                                    label="Transaction Date"
                                    value={row.header.transactionAt}
                                    onChange={(e) => {
                                       let value = e.target.value; // yyyy-mm-dd

                                       const parts = value.split('-');
                                       if (parts[0]?.length > 4) {
                                          parts[0] = parts[0].slice(0, 4);
                                          value = parts.join('-');
                                       }
                                       handleInputChange('header', {
                                          target: {
                                             name: e.target.name,
                                             value,
                                          },
                                       });
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, accountRef, docNoRef)}
                                 />
                              </GridItem>

                              {/* 👉 Account field  */}
                              <GridItem w="100%">
                                 <AccountSelect
                                    ref={accountRef}
                                    name="accountId"
                                    options={accountData}
                                    label="Account"
                                    value={row.header.accountId}
                                    errors={errors}
                                    errorName="header.accountId"
                                    isClearable
                                    isSearchable
                                    isDisabled={filedDisabled}
                                    onChange={(value) => {
                                       handleAccount('accountId', value);
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, partyBillNoRef, transactionAtRef)}
                                    showCustomNoOptions={true}
                                    openfrom="purchase"
                                    glGroup={targetGlGroup}
                                 />
                              </GridItem>

                              {/* 👉 Party Bill No field  */}
                              <GridItem w="100%">
                                 <InputField
                                    ref={partyBillNoRef}
                                    type="text"
                                    name="partyNo"
                                    errorName="header.partyNo"
                                    label="Party Bill No"
                                    value={row.header.partyNo}
                                    onChange={(e) => handleInputChange('header', e)}
                                    errors={errors}
                                    onKeyDown={(e) => handleKeyDown(e, partyDateRef, accountRef)}
                                 />
                              </GridItem>

                              {/* 👉 Party Bill Date field  */}
                              <GridItem w="100%">
                                 <InputField
                                    ref={partyDateRef}
                                    type="date"
                                    name="partyDate"
                                    label="Party Bill Date"
                                    value={row.header.partyDate}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={(e) => handleKeyDown(e, brokerRef, partyBillNoRef)}
                                 />
                              </GridItem>

                              {/* 👉 Broker field  */}
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'brokerId',
                                    'Broker',
                                    accountData,
                                    {
                                       errorName: 'header.brokerId',
                                       value: row.header.brokerId,
                                       onChange: (value) => handleAccount('brokerId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: brokerRef,
                                       nextRef: supplierRef,
                                       onKeyDown: (e) => {
                                          if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                             e.preventDefault();
                                             supplierRef.current.focus();
                                             // itemRefs?.current[0]?.focus();
                                          }
                                          if (e.key === 'Tab' && e.shiftKey) {
                                             e.preventDefault();
                                             partyDateRef.current.focus();
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'account',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Broker',
                                 )}
                              </GridItem>

                              {/* 👉 Salesman field  */}
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'representativeId',
                                    'Saleman',
                                    salesManList,
                                    {
                                       errorName: 'header.representativeId',
                                       value: row.header.representativeId,
                                       onChange: (value) => handleAccount('representativeId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: supplierRef,
                                       nextRef: issueDocRef,
                                       // onKeyDown: (e) => {
                                       //    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                       //       e.preventDefault();
                                       //       if (issueDocRef.current) {
                                       //          issueDocRef.current.focus();
                                       //       } else if (issueDocRefs.current[0]) {
                                       //          issueDocRefs.current[0].focus();
                                       //       } else if (
                                       //          companyData?.setting?.warehouseWishStock === true &&
                                       //          herderview === true
                                       //       ) {
                                       //          wareHouseRef.current.focus();
                                       //       } else {
                                       //          itemRefs?.current[0]?.focus();
                                       //       }
                                       //    }
                                       // },
                                       onKeyDown: (e) => {
                                          e.preventDefault();
                                          if (daybook?.isAskIncomeExpenses) {
                                             handleKeyDown(e, incomeRef, brokerRef);
                                             return;
                                          }
                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             handleKeyDown(e, wareHouseRef, brokerRef);
                                             return;
                                          }
                                          if (millIssueDocRef.current) {
                                             handleKeyDown(e, millIssueDocRef, brokerRef);
                                             return;
                                          }
                                          if (orderDocRef.current) {
                                             handleKeyDown(e, orderDocRef, brokerRef);
                                             return;
                                          }
                                          if (challanDocRef.current) {
                                             handleKeyDown(e, challanDocRef, brokerRef);
                                             return;
                                          }
                                          if (e.key === 'Enter' || e.key === 'Tab') {
                                             if (e.shiftKey) {
                                                brokerRef?.current?.focus();
                                             } else {
                                                // 👉 old condition: companyData?.setting?.warehouseWishStock === true && (lineitemview === true || lineDetailview === true)
                                                if (companyData?.setting?.warehouseWishStock === true && lineitemview) {
                                                   warehouseRef?.current[0]?.focus();
                                                }
                                                // if () {

                                                // }
                                                else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'Saleman',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Saleman',
                                 )}
                              </GridItem>

                              {/* 👉 Income field   */}
                              {daybook?.isAskIncomeExpenses ? (
                                 <GridItem w="100%">
                                    <AccountSelect
                                       ref={incomeRef}
                                       name="incomeId"
                                       options={incomeAccounts}
                                       label="Expenses Account"
                                       value={row.header.incomeId}
                                       errors={errors}
                                       errorName="header.incomeId"
                                       isClearable
                                       isSearchable
                                       onChange={(value) => {
                                          handleAccount('incomeId', value);
                                       }}
                                       onKeyDown={(e) => {
                                          if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                             e.preventDefault();
                                             if (issueDocRef?.current) {
                                                issueDocRef?.current?.focus();
                                                return;
                                             }
                                             if (millIssueDocRef?.current) {
                                                millIssueDocRef?.current?.focus();
                                                return;
                                             }
                                             if (companyData?.setting?.warehouseWishStock === true && lineitemview) {
                                                warehouseRef?.current[0]?.focus();
                                                return;
                                             }
                                             if (orderDocRef?.current) {
                                                orderDocRef?.current?.focus();
                                                return;
                                             }
                                             if (challanDocRef?.current) {
                                                challanDocRef?.current?.focus();
                                                return;
                                             }
                                             if (itemRefs?.current[0]) {
                                                itemRefs?.current[0]?.focus();
                                                return;
                                             }
                                          }
                                       }}
                                       showCustomNoOptions={true}
                                       openfrom="salesdaybook"
                                       glGroup={targetGlGroup}
                                    />
                                 </GridItem>
                              ) : null}

                              {/* 👉 Issue Document field for Mobile   */}
                              {daybook && daybook?.issuedaybookid && businessTypes?.businessType?.toUpperCase() === 'MOBILE' ? (
                                 <GridItem w="100%">
                                    {dynamicDropdown(
                                       'issueDoc',
                                       'Issued Document',
                                       issueDocument.map((x) => ({
                                          label: `${x.itemName} ${x.issued_serial_no ? `(${x.issued_serial_no})` : ''}`,
                                          id: x.issue_linedetail_id,
                                       })),
                                       {
                                          errorName: 'header.issueDoc',
                                          value: issuedDoc,
                                          onChange: (value) => {
                                             setIssuedDoc(value);
                                             if (row.header.accountId) {
                                             } else if (value?.length === 1) {
                                                const findData = issueDocument.filter(
                                                   (data) => data.issue_linedetail_id === value[0],
                                                );
                                                if (findData?.length > 0) {
                                                   handleAccount('accountId', findData[0].accountId);
                                                   accountRef.current.focus();
                                                }
                                             }
                                          },
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          ref: issueDocRef,
                                          nextRef: itemRefs?.current[0],
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault();
                                                if (millIssueDocRef?.current) {
                                                   millIssueDocRef?.current?.focus();
                                                   return;
                                                }
                                                if (companyData?.setting?.warehouseWishStock === true && lineitemview) {
                                                   warehouseRef?.current[0]?.focus();
                                                   return;
                                                }
                                                if (orderDocRef?.current) {
                                                   orderDocRef?.current?.focus();
                                                   return;
                                                }
                                                if (challanDocRef?.current) {
                                                   challanDocRef?.current?.focus();
                                                   return;
                                                }
                                                if (itemRefs?.current[0]) {
                                                   itemRefs?.current[0]?.focus();
                                                   return;
                                                }
                                             }
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Broker',
                                       true, // isSearchable
                                       undefined, // filteredOptions
                                       true, // isMulti
                                    )}
                                 </GridItem>
                              ) : null}

                              {/* 👉 Issue Document field for Textile   */}
                              {daybook && daybook?.issuedaybookid && daybook?.isMillReceive && businessTypes?.businessType?.toUpperCase() === 'TEXTILE' && (challanDoc?.length === 0 && orderDoc?.length === 0) ? (
                                 <GridItem w="100%">
                                    {dynamicDropdown(
                                       'millIssueDoc',
                                       'Issued Document',
                                       millIssueDocument?.map((x) => ({
                                          label: `Bill NO: ${x.docNo}\n Item Name: ${x.itemName}\n ${x.accountName ? `( ${x.accountName} )` : ''}\n ${x.pendingQty1 ? `(Qty 1 :- ${x.pendingQty1})` : ''} ${x.pendingQty2 ? `(Qty 2 :- ${x.pendingQty2})` : ''} ${x.pendingQty3 ? `(Qty 3 :- ${x.pendingQty3})` : ''}`,
                                          id: x.id
                                       })),
                                       {
                                          errorName: 'header.millIssueDoc',
                                          value: millIssueDoc,
                                          onChange: (value) => {
                                             setMillIssueDoc(value);
                                             if (value?.length === 0) {
                                                if (id) {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.issueLineId || (item.issueLineId && item.id))
                                                         .map((item) => {

                                                            const lineItem = salesInvoice?.lineitems?.find((x) => x.id === item.id);
                                                            return {
                                                               ...lineItem, gstWithRate: item.gstWithRate ? item.gstWithRate : null, isDeleted: false, gst: item.gstPercent, unit: item.ratePer, takaDetails: lineItem?.purchaseLineDetail?.map((x) => {
                                                                  return { ...x, quantity3: x.quantity3, mts: x.mts || x.quantity3, usedMeter: x.RQuantity3 };
                                                               })
                                                            }
                                                         });
                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                } else {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.issueLineId && item.itemId)
                                                         .map((item) => ({ ...item }));

                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                }
                                             }


                                             if (row.header.accountId) {
                                             } else if (value?.length === 1) {
                                                const findData = issueDocument.filter(
                                                   (data) => data.issue_lineitem_id === value[0],
                                                );
                                                console.log("millIssueDoc", value, row.header, issueDocument, findData);
                                                if (findData?.length > 0) {
                                                   handleAccount('accountId', findData[0].accountId);
                                                   accountRef.current.focus();
                                                }
                                             }
                                          },
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          ref: millIssueDocRef,
                                          nextRef: itemRefs?.current[0],
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault();
                                                if (companyData?.setting?.warehouseWishStock === true && lineitemview) {
                                                   warehouseRef?.current[0]?.focus();
                                                   return;
                                                }
                                                if (orderDocRef?.current) {
                                                   orderDocRef?.current?.focus();
                                                   return;
                                                }
                                                if (challanDocRef?.current) {
                                                   challanDocRef?.current?.focus();
                                                   return;
                                                }
                                                if (itemRefs?.current[0]) {
                                                   itemRefs?.current[0]?.focus();
                                                   return;
                                                }
                                             }
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Broker',
                                       true, // isSearchable
                                       undefined, // filteredOptions
                                       true, // isMulti
                                    )}
                                 </GridItem>
                              ) : null}

                              {/* 👉 Warehouse field */}
                              {companyData?.setting?.warehouseWishStock === true && herderview === true && (
                                 <GridItem className="seperator-width">
                                    {renderDynamicDropdown(
                                       'warehouseId',
                                       'Ware House',
                                       warehouseList,
                                       {
                                          value: row.header.warehouseId,
                                          onChange: (value) => handleAccount('warehouseId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'wareHouse',
                                          ref: wareHouseRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (daybook?.isAskIncomeExpenses) {
                                                      incomeRef?.current?.focus();
                                                   } else {
                                                      supplierRef?.current?.focus();
                                                   }
                                                } else {
                                                   if (orderDocRef?.current) {
                                                      orderDocRef?.current?.focus();
                                                      return;
                                                   }
                                                   if (challanDocRef?.current) {
                                                      challanDocRef?.current?.focus();
                                                      return;
                                                   }
                                                   if (itemRefs?.current[0]) {
                                                      itemRefs?.current[0]?.focus();
                                                      return;
                                                   }
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Ware House',
                                    )}
                                 </GridItem>
                              )}

                              {/* 👉 Order Document field */}
                              {daybook && daybook?.orderFieldRegion === 0 && userType !== 'MOBILE' && (challanDoc?.length === 0 && millIssueDoc?.length === 0) ? (
                                 <GridItem w="100%">
                                    {dynamicDropdown(
                                       'orderDoc',
                                       'Order Document',
                                       orderDocument?.map((x) => ({
                                          label: `${x.itemName} ${x.accountName ? `( ${x.accountName} )` : ''} ${x.pendingQty1 ? `(Qty 1 :- ${x.pendingQty1})` : ''} ${x.pendingQty2 ? `(Qty 2 :- ${x.pendingQty2})` : ''} ${x.pendingQty3 ? `(Qty 3 :- ${x.pendingQty3})` : ''}`,
                                          id: x.id,
                                       })),
                                       {
                                          errorName: 'header.orderDoc',
                                          value: orderDoc,
                                          onChange: (value) => {
                                             setOrderDoc(value);

                                             if (value?.length === 0) {
                                                if (id) {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.poliId || (item.poliId && item.id))
                                                         .map((item) => ({ ...item }));

                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                } else {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.poliId && item.itemId)
                                                         .map((item) => ({ ...item }));

                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                }
                                             }

                                             if (row.header.accountId) {
                                             } else if (value?.length === 1) {
                                                const findData = orderDocument.filter(
                                                   (data) => data.id === value[0],
                                                );
                                                if (findData?.length > 0) {
                                                   handleAccount('accountId', findData[0].accountId);
                                                   accountRef.current.focus();
                                                }
                                             }


                                          },
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          ref: orderDocRef,
                                          nextRef: itemRefs?.current[0],
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault();
                                                if (challanDocRef?.current) {
                                                   challanDocRef?.current?.focus();
                                                   return;
                                                }
                                                if (itemRefs?.current[0]) {
                                                   itemRefs?.current[0]?.focus();
                                                   return;
                                                }
                                             }
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Broker',
                                       true, // isSearchable
                                       undefined, // filteredOptions
                                       true, // isMulti
                                    )}
                                 </GridItem>
                              ) : null
                              }

                              {/* 👉 Challan Document field */}
                              {daybook && daybook?.challanFieldRegion === 0 && userType !== 'MOBILE' && (orderDoc?.length === 0 && millIssueDoc?.length === 0) ? (
                                 <GridItem w="100%">
                                    {dynamicDropdown(
                                       'ChallanDoc',
                                       'Challan Document',
                                       challanDocument?.map((x) => ({
                                          label: `${x.itemName} ${x.accountName ? `( ${x.accountName} )` : ''} ${x.pendingQty1 ? `(Qty 1 :- ${x.pendingQty1})` : ''} ${x.pendingQty2 ? `(Qty 2 :- ${x.pendingQty2})` : ''} ${x.pendingQty3 ? `(Qty 3 :- ${x.pendingQty3})` : ''}`,
                                          id: x.id,
                                       })),
                                       {
                                          errorName: 'header.ChallanDoc',
                                          value: challanDoc,
                                          onChange: (value) => {
                                             setChallanDoc(value);

                                             if (value?.length === 0) {
                                                if (id) {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.pcliId || (item.pcliId && item.id))
                                                         .map((item) => ({ ...item }));

                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                } else {
                                                   setRow((prev) => {
                                                      const filtered = (prev.lineItem || [])
                                                         .filter((item) => !item.pcliId && item.itemId)
                                                         .map((item) => ({ ...item }));

                                                      return {
                                                         ...prev,
                                                         lineItem: filtered.length > 0 ? filtered : [initialLineItem],
                                                      }
                                                   });
                                                }
                                             }

                                             if (row.header.accountId) {
                                             } else if (value?.length === 1) {
                                                const findData = challanDocument.filter(
                                                   (data) => data.id === value[0],
                                                );
                                                if (findData?.length > 0) {
                                                   handleAccount('accountId', findData[0].accountId);
                                                   accountRef.current.focus();
                                                }
                                             }
                                          },
                                          focusBorderColor: 'blue.500',
                                          _focus: {
                                             boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                          },
                                          ref: challanDocRef,
                                          nextRef: itemRefs?.current[0],
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                                e.preventDefault();
                                                if (itemRefs?.current[0]) {
                                                   itemRefs?.current[0]?.focus();
                                                   return;
                                                }
                                             }
                                          },
                                          showCustomNoOptions: true,
                                          openfrom: 'account',
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Broker',
                                       true, // isSearchable
                                       undefined, // filteredOptions
                                       true, // isMulti
                                    )}
                                 </GridItem>
                              ) : null
                              }
                           </Grid >

                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%" colSpan={4}>
                                 <Box my={3}>
                                    <LineItem
                                       addLineItem={addLineItem}
                                       lineItems={row.lineItem}
                                       itemData={itemData}
                                       textColor={textColor}
                                       lastDaybook={daybook}
                                       removeLineItem={removeLineItem}
                                       handleOnChange={handleOnChange}
                                       companyData={companyList}
                                       totals={totals}
                                       handleStockModalOnClick={handleStockModalOnClick}
                                       handleStockModal={handleStockModal}
                                       errors={errors}
                                       refs={refs}
                                       prerefs={
                                          daybook && daybook?.challanFieldRegion === 0 && orderDoc?.length === 0 && userType !== 'MOBILE'
                                             ? challanDocRef
                                             : daybook && daybook?.orderFieldRegion === 0 && challanDoc?.length === 0 && userType !== 'MOBILE'
                                                ? orderDocRef
                                                : companyData?.setting?.warehouseWishStock === true && herderview === true
                                                   ? wareHouseRef
                                                   : daybook && daybook?.issuedaybookid && daybook?.isMillReceive && businessTypes?.businessType?.toUpperCase() === 'TEXTILE'
                                                      ? millIssueDocRef
                                                      : daybook && daybook?.issuedaybookid && businessTypes?.businessType?.toUpperCase() === 'MOBILE'
                                                         ? issueDocRef
                                                         : daybook?.isAskIncomeExpenses
                                                            ? incomeRef
                                                            : supplierRef
                                       }
                                       type="purchase"
                                       warehouseList={warehouseList}
                                       lineitemview={lineitemview}
                                       lineDetailview={lineDetailview}
                                       selectcompany={companyData}
                                       billTermData={billTermData}
                                       setCurrentLineItemIdx={setCurrentIndex}
                                    />
                                 </Box>
                              </GridItem>
                           </Grid>

                           <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(4, 1fr)" gap={3}>
                              <GridItem w="100%" colSpan={2}>
                                 <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDaysRef}
                                          type="number"
                                          name="dueDays"
                                          label="Due Days"
                                          value={row.header.dueDays}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }
                                             if (e.key === 'Tab' && e.shiftKey) {
                                                if (refs?.amountRefs?.current) {
                                                   const lastIndex = refs.amountRefs?.current?.length - 1;
                                                   refs.amountRefs.current[lastIndex]?.focus();
                                                }
                                             }
                                             handleKeyDown(e, dueDateRef);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </GridItem>

                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDateRef}
                                          type="date"
                                          name="dueAt"
                                          label="Due Date"
                                          value={row.header.dueAt}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => handleKeyDown(e, notesRef, dueDaysRef)}
                                       />
                                    </GridItem>


                                    {showTds && (
                                       <>
                                          <GridItem w="100%">
                                             <InputField
                                                ref={tdsRateRef}
                                                type="number"
                                                name="tdsRate"
                                                label="TDS Rate (%)"
                                                min={0}
                                                max={100}
                                                value={row.header.tdsRate}
                                                onChange={(e) => {
                                                   const val = parseFloat(e.target.value);
                                                   if (e.target.value === '' || e.target.value === null) {
                                                      handleInputChange('header', e);
                                                      return;
                                                   }
                                                   if (val < 0 || val > 100) return;
                                                   handleInputChange('header', e);
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                             />
                                          </GridItem>

                                          <GridItem w="100%">
                                             <InputField
                                                ref={tdsAmountRef}
                                                type="number"
                                                name="tdsAmount"
                                                label="TDS Amount"
                                                value={row.header.tdsAmount}
                                                onChange={(e) => handleInputChange('header', e)}
                                                onWheel={(e) => e.target.blur()}
                                             />
                                          </GridItem>
                                       </>
                                    )}

                                    {id && salesInvoice && salesInvoice.tdsRate > 0 && (
                                       <GridItem w="100%" colSpan={2}>
                                          <Box
                                             display="flex"
                                             alignItems="center"
                                             gap={2}
                                             px={3}
                                             py={2}
                                             borderRadius="lg"
                                             // bgGradient="linear(to-r, blue.50, blue.100)"
                                             bgGradient="linear(to-r, to-r, to-r)"
                                             border="1px solid"
                                             borderColor="blue.300"
                                             _dark={{
                                                bgGradient: 'linear(to-r, blue.900, blue.800)',
                                                borderColor: 'blue.600',
                                             }}
                                          >
                                             <Icon as={FaCircleInfo} color="blue.500" boxSize={4} flexShrink={0} />

                                             <Text fontSize="sm" color="gray.700" _dark={{ color: 'gray.300' }}>
                                                TDS Rate:
                                                <Text as="span" ml={1} mr={3} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   {Number(salesInvoice.tdsRate || 0).toFixed(2)}%,
                                                </Text>

                                                TDS Amt:
                                                <Text as="span" ml={1} mr={3} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   ₹{Number(salesInvoice.tdsAmount || 0).toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })},
                                                </Text>

                                                TDS Calc. ON:
                                                <Text as="span" ml={1} mr={3} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   ₹{Number(
                                                      salesInvoice.tdsRate > 0
                                                         ? salesInvoice.tdsAmount * 100 / salesInvoice.tdsRate
                                                         : 0
                                                   ).toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })},
                                                </Text>

                                                To Pay:
                                                <Text as="span" ml={1} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   ₹{Number(
                                                      (salesInvoice.netAmount || 0) - (salesInvoice.tdsAmount || 0)
                                                   ).toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })},
                                                </Text>
                                             </Text>
                                          </Box>
                                       </GridItem>
                                    )}

                                    <GridItem w="100%" colSpan={2}>
                                       <TextareaField
                                          ref={notesRef}
                                          name="notes"
                                          label="Notes"
                                          value={row.header.notes}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (
                                                (e.key === 'Enter' && !e.shiftKey) ||
                                                (e.key === 'Tab' && !e.shiftKey)
                                             ) {
                                                e.preventDefault();
                                                paymentRefs?.current[0]?.focus();
                                             }
                                             if (e.key === 'Tab' && e.shiftKey) {
                                                e.preventDefault();
                                                dueDateRef?.current?.focus();
                                             }
                                          }}
                                       />
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       {selectedStocks?.length > 0 ? (
                                          <TableContainer
                                             border="1px"
                                             borderColor="gray.200"
                                             borderRadius={5}
                                             maxH="300px"
                                             overflowY="auto">
                                             <Table variant="simple" size="sm">
                                                <Thead bg="gray.200">
                                                   <Tr>
                                                      <Th>Item</Th>
                                                      <Th>Series No</Th>
                                                      {/* <Th isNumeric>Stock</Th> */}
                                                      <Th>Warehouse</Th>
                                                      <Th>Action</Th>
                                                   </Tr>
                                                </Thead>
                                                <Tbody>
                                                   {selectedStocks &&
                                                      removeDuplicates(selectedStocks, 'serialNo')?.map(
                                                         (item, index) => {
                                                            return (
                                                               <Tr key={index}>
                                                                  <Td>{item?.itemName}</Td>
                                                                  <Td>
                                                                     {item?.serialNo}
                                                                     <Icon
                                                                        as={FaHistory}
                                                                        boxSize={4}
                                                                        ml={3}
                                                                        color="green.600"
                                                                        onClick={() => handleSerialHistory(item)}
                                                                        cursor="pointer"
                                                                     />
                                                                  </Td>
                                                                  {/* <Td isNumeric>{item.pcs}</Td> */}
                                                                  <Td>{warehouseMap[item.warehouseId] || 'N/A'}</Td>
                                                                  <Td>
                                                                     <IconButton
                                                                        colorScheme="red"
                                                                        size="sm"
                                                                        isDisabled={item.processStatus === "ISSUE" || item.processStatus === "SALES"}
                                                                        onClick={() => removeStock(item)}
                                                                        icon={<FaTrash />}
                                                                     />
                                                                  </Td>
                                                               </Tr>
                                                            );
                                                         },
                                                      )}
                                                </Tbody>
                                             </Table>
                                          </TableContainer>
                                       ) : null}
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                          {paymentData?.map((payment, idx) => {
                                             return (
                                                <GridItem w="100%" key={idx}>
                                                   <InputField
                                                      ref={(el) => {
                                                         if (paymentRefs && paymentRefs.current) {
                                                            paymentRefs.current[idx] = el;
                                                         }
                                                      }}
                                                      type="number"
                                                      name={`amount`}
                                                      label={`${payment.daybookName} AMOUNT`}
                                                      value={payment.amount}
                                                      onChange={(e) => handlePaymentOnChange(e, idx)}
                                                      onKeyDown={(e) => {
                                                         if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                         }
                                                         if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            if (paymentRefs?.current[idx + 1]) {
                                                               paymentRefs?.current[idx + 1].focus();
                                                            } else {
                                                               if (submitRef.current) {
                                                                  submitRef.current.focus();
                                                               }
                                                            }
                                                         }

                                                         if (e.key === 'Tab' && !e.shiftKey) {
                                                            e.preventDefault();
                                                            if (paymentRefs?.current[idx + 1]) {
                                                               paymentRefs?.current[idx + 1].focus();
                                                            } else {
                                                               if (submitRef.current) {
                                                                  submitRef.current.focus();
                                                               }
                                                            }
                                                         }
                                                      }}
                                                      onWheel={(e) => e.target.blur()}
                                                   />
                                                </GridItem>
                                             );
                                          })}
                                       </Grid>
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem colSpan={2}>
                                       <BillTerm
                                          textColor={textColor}
                                          billTermData={row.header.daybookId > 0 ? billTermData : []}
                                          billTerms={row.header.daybookId > 0 ? billTerms : []}
                                          netAmount={totals.netAmount}
                                          handleBillTermChange={handleBillTermChange}
                                          refs={refs}
                                       />
                                    </GridItem>
                                    <GridItem w="100%" colSpan={2}>
                                       <TaxableAmount
                                          totals={totals}
                                          isSameState={isSameState}
                                          finalNetAmount={finalNetAmount}
                                          daybook={filteredDaybooks.find((item) => item.id === row?.header?.daybookId)}
                                          company={company}
                                       />
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                           </Grid>
                        </form >
                        <CardFooter justifyContent="flex-end" gap={3}>
                           <Button
                              ref={submitRef}
                              colorScheme="green"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="full"
                              _active={{ bg: '#06b' }}
                              onClick={() => handleAskToVerifyCustomer()}
                              isLoading={isLoading}
                              loadingText={id ? 'Updating...' : 'Saving...'}
                              disabled={isLoading}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'Tab' && e.shiftKey) {
                                    e.preventDefault();
                                    // Focus the last paymentRefs element
                                    const lastIndex = paymentRefs?.current?.length - 1;
                                    paymentRefs.current[lastIndex]?.focus();
                                 } else if (e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    closeRef.current?.focus();
                                 }
                              }}>
                              {id ? 'Update' : 'Save'}
                           </Button>
                           <Button
                              ref={closeRef}
                              colorScheme="red"
                              onClick={() => {
                                 dispatch(emptyPurchase());
                                 handleReset();
                                 navigate('/admin/purchase/invoice');
                              }}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowLeft') {
                                    e.preventDefault();
                                    submitRef.current?.focus();
                                 }
                              }}>
                              Cancel
                           </Button>
                        </CardFooter>
                     </>
                  )}
               </Box >
            </CardBody >
         </Card >

         <SerialNumberModal
            isOpen={isOpenModal}
            onClose={onCloseModal}
            selectedDaybook={selectedDaybook}
            handleStock={handleStock}
            itemStocks={itemStocks}
            itemId={lastItemId}
            onCloseComplete={() => {
               setTimeout(() => {
                  if (daybook?.isAllowGstRate && company?.setting?.applyGST && daybook?.applyGst) {
                     gstRateRefs.current[currentIndex]?.focus();
                  } else {
                     rateRefs.current[currentIndex]?.focus();
                  }
               }, 0);
            }}
            setItemStocks={setItemStocks}
            removeStock={removeStock}
            warehouseList={warehouseList}
            lineitemview={lineDetailview}
            selectcompany={companyData}
            textColor={textColor}
            selectdaybookdata={selectdaybookdata}
            lineitem={row.lineItem}
            headerId={id && id > 0 ? id : null}
         />

         <IssueToMill
            isOpen={isOpenIssueToMillModal}
            onClose={onCloseIssueToMillModal}
            daybookData={daybookData}
            brokerData={accountData}
            issueData={issueData}
         />

         <CustomerVerifyModal
            isOpen={isOpenVerifyModal}
            onClose={onCloseVerifyModal}
            accountId={row.header.accountId}
            entryData={salesInvoice}
            handleSubmit={handleSubmit}
            mobile={account?.mobile}
            account={account}
            isLoading={isLoading}
            entryType="purchase"
            invoiceImages={invoiceImages}
            setInvoiceImages={setInvoiceImages}
         />

         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Delete Line Item"
         />

         {/* Print Format Moal  */}
         <PrintFormat
            isOpen={isOpenPrintFormatModal}
            onClose={onClosePrintFormatModal}
            daybook={daybook}
            functionName="Purchase Invoices"
            redirect="/admin/purchase/invoice"
         />

         <TakaForm
            isOpen={isOpenTakaModal}
            onClose={onCloseTakaModal}
            handleTakaDetails={handleTakaDetails}
            currentTakaDetails={currentTakaDetails}
            onCloseComplete={() => {
               setTimeout(() => {
                  rateRefs.current[currentIndex]?.focus();
               }, 0);
            }}
         />

         <SelectTakaDetail
            isOpen={isOpenTakaDetailModal}
            onClose={onCloseTakaDetailModal}
            takaDetails={takaDetails}
            handleSaveTakaDetail={handleSaveTakaDetail}
            selectedTakaDetails={selectedTakaDetails}
            onCloseComplete={() => {
               setTimeout(() => {
                  rateRefs.current[currentIndex]?.focus();
               }, 0);
            }}
            lineItem={row.lineItem}
            currentIndex={currentIndex}
         />

         <SelectTakaDetailChallan
            isOpen={isOpenTakaDetailChallanModal}
            onClose={onCloseTakaDetailChallanModal}
            takaDetails={takaDetails}
            handleSaveTakaDetail={handleSaveTakaDetailChallan}
            lineItem={row.lineItem}
            currentIdx={currentIndex}
            formType={id ? 'edit' : 'add'}
            invoiceType={invoiceType}
         />

         <Modal isOpen={isOpenSerialhistory} onClose={onCloseSerialhistory} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Serial History({data[0]?.serial_no})</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {data?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              <Th>Transaction at</Th>
                              <Th>Transaction Type</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Item Rate</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {data?.map((data, index) => (
                              <Tr key={index}>
                                 <Td>{data?.doc_no}</Td>
                                 <Td>{new Date(data?.transaction_at).toLocaleDateString('en-GB')}</Td>
                                 <Td>{data?.transaction_type}</Td>
                                 <Td>{data?.account_name}</Td>
                                 <Td>{data?.daybook_name}</Td>
                                 <Td>{data?.item_rate}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No transaction history found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         <Modal isOpen={isOpenAdjustedDocs} onClose={onCloseAdjustedDocs} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Adjusted Docs</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {adjustedDocs?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              {/* <Th>Transaction at</Th> */}
                              {/* <Th>Transaction Type</Th> */}
                              <Th>Txn Date</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Amount</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {adjustedDocs?.map((txn, index) => (
                              <Tr key={index}>
                                 <Td>{txn.adj_docno}</Td>
                                 {/* <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td> */}
                                 {/* <Td>{txn.transaction_type}</Td> */}
                                 <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td>
                                 <Td>{txn.adj_accountname}</Td>
                                 <Td>
                                    {selectedDaybookData?.length > 0
                                       ? txn.adj_daybookname === selectedDaybookData[0]?.name
                                          ? txn.daybookname
                                          : txn.adj_daybookname
                                       : txn.adj_daybookname}
                                 </Td>
                                 <Td>{txn.amount}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No Adjusted Docs Data found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>
      </>
   );
};

export default PurchaseInvoiceForm;
